webpackJsonp([10],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var MessageContentType = function MessageContentType() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MessageContentType);
};

MessageContentType.Unknown = 0;
MessageContentType.Text = 1;
MessageContentType.Voice = 2;
MessageContentType.Image = 3;
MessageContentType.Location = 4;
MessageContentType.File = 5;
MessageContentType.Video = 6;
MessageContentType.Sticker = 7;
MessageContentType.ImageText = 8;
MessageContentType.P_Text = 9;
MessageContentType.RecallMessage_Notification = 80;
MessageContentType.Tip_Notification = 90;
MessageContentType.Typing = 91;
MessageContentType.CreateGroup_Notification = 104;
MessageContentType.AddGroupMember_Notification = 105;
MessageContentType.KickOffGroupMember_Notification = 106;
MessageContentType.QuitGroup_Notification = 107;
MessageContentType.DismissGroup_Notification = 108;
MessageContentType.TransferGroupOwner_Notification = 109;
MessageContentType.ChangeGroupName_Notification = 110;
MessageContentType.ModifyGroupAlias_Notification = 111;
MessageContentType.ChangeGroupPortrait_Notification = 112;
MessageContentType.MuteGroupMember_Notification = 113;
MessageContentType.ChangeJoinType_Notification = 114;
MessageContentType.ChangePrivateChat_Notification = 115;
MessageContentType.ChangeSearchable_Notificaiton = 116;
MessageContentType.SetGroupManager_Notification = 117;
MessageContentType.VOIP_CONTENT_TYPE_START = 400;
MessageContentType.VOIP_CONTENT_TYPE_END = 402;
MessageContentType.VOIP_CONTENT_TYPE_ACCEPT = 401;
MessageContentType.VOIP_CONTENT_TYPE_SIGNAL = 403;
MessageContentType.VOIP_CONTENT_TYPE_MODIFY = 404;
MessageContentType.VOIP_CONTENT_TYPE_ACCEPT_T = 405;
/* harmony default export */ __webpack_exports__["a"] = (MessageContentType);

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONNECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISCONNECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONNECT_ACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PUBLISH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PUB_ACK; });
/* unused harmony export FRP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPUI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return GPGI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return GPGM; });
/* unused harmony export GAM */
/* unused harmony export GC */
/* unused harmony export GMI */
/* unused harmony export GKM */
/* unused harmony export GQ */
/* unused harmony export GD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return MP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return MS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MN; });
/* unused harmony export MR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return RMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return GQNUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GMURL; });
/* unused harmony export US */
/* unused harmony export FAR */
/* unused harmony export FRN */
/* unused harmony export FHR */
/* unused harmony export FN */
/* unused harmony export MMI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return KEY_DEVICE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return KEY_USER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return KEY_TOKEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LAST_MESSAGE_SEQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SEND_MESSAGE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FRIEND_REQUEST_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SEND_MESSAGE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return USER_INFO_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return USER_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return USER_CONVERSATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFACULT_VUE_IMG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ERROR_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return SUCCESS_CODE; });

var CONNECT = 'CONNECT';
var DISCONNECT = 'DISCONNECT';
var CONNECT_ACK = 'CONNECT_ACK';
var PUBLISH = 'PUBLISH';
var PUB_ACK = 'PUB_ACK';

var FRP = 'FRP';
var FP = 'FP';
var UPUI = 'UPUI';
var GPGI = 'GPGI';
var GPGM = 'GPGM';
var GAM = 'GAM';
var GC = 'GC';
var GMI = 'GMI';
var GKM = 'GKM';
var GQ = 'GQ';
var GD = 'GD';
var MP = 'MP';
var MS = "MS";
var MN = "MN";
var MR = "MR";
var RMN = "RMN";
var GQNUT = "GQNUT";
var GMURL = "GMURL";
var US = "US";
var FAR = "FAR";
var FRN = "FRN";
var FHR = "FHR";
var FN = "FN";
var MMI = "MMI";

var KEY_DEVICE_ID = 'key_device_id';
var KEY_USER_ID = 'key_user_id';
var KEY_TOKEN = 'key_token';
var LAST_MESSAGE_SEQ = "key_last_message_seq";
var SEND_MESSAGE_COUNT = "key_send_message_count";
var FRIEND_REQUEST_VERSION = "key_friend_request_version";
var SEND_MESSAGE_ID = "key_send_message_id";
var USER_INFO_LIST = "key_user_infos_list";
var USER_MESSAGES = "key_user_messages";
var USER_CONVERSATIONS = "key_user_coversations";

var DEFACULT_VUE_IMG = "../../assets/img/uimg/u__qun-vue.png";

var ERROR_CODE = 400;
var SUCCESS_CODE = 200;

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant_system__ = __webpack_require__(10);





var LocalStore = function () {
    function LocalStore() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LocalStore);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LocalStore, null, [{
        key: "setDeviceId",
        value: function setDeviceId(deviceId) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["l" /* KEY_DEVICE_ID */], deviceId);
        }
    }, {
        key: "getDeviceId",
        value: function getDeviceId() {
            return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["l" /* KEY_DEVICE_ID */]);
        }
    }, {
        key: "setUserId",
        value: function setUserId(userId) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["n" /* KEY_USER_ID */], userId);
        }
    }, {
        key: "getUserId",
        value: function getUserId() {
            return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["n" /* KEY_USER_ID */]);
        }
    }, {
        key: "setToken",
        value: function setToken(token) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["m" /* KEY_TOKEN */], token);
        }
    }, {
        key: "getToken",
        value: function getToken() {
            return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["m" /* KEY_TOKEN */]);
        }
    }, {
        key: "isLogin",
        value: function isLogin() {
            return this.getToken() && this.getToken() != '';
        }
    }, {
        key: "getLastMessageSeq",
        value: function getLastMessageSeq() {
            return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["o" /* LAST_MESSAGE_SEQ */]);
        }
    }, {
        key: "setLastMessageSeq",
        value: function setLastMessageSeq(messageSeq) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["o" /* LAST_MESSAGE_SEQ */], messageSeq);
        }
    }, {
        key: "getSendMessageCount",
        value: function getSendMessageCount() {
            var value = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["v" /* SEND_MESSAGE_COUNT */]);
            if (!value) {
                value = 0;
            }
            return value;
        }
    }, {
        key: "updateSendMessageCount",
        value: function updateSendMessageCount() {
            var value = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["v" /* SEND_MESSAGE_COUNT */]);
            if (value) {
                value = parseInt(value) + 1;
            } else {
                value = 1;
            }
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["v" /* SEND_MESSAGE_COUNT */], value);
        }
    }, {
        key: "resetSendMessageCount",
        value: function resetSendMessageCount() {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["v" /* SEND_MESSAGE_COUNT */], 0);
        }
    }, {
        key: "setFriendRequestVersion",
        value: function setFriendRequestVersion(version) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["g" /* FRIEND_REQUEST_VERSION */], version);
        }
    }, {
        key: "getFriendRequestVersion",
        value: function getFriendRequestVersion() {
            return localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["g" /* FRIEND_REQUEST_VERSION */]);
        }
    }, {
        key: "saveMessageId",
        value: function saveMessageId(messageId) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["w" /* SEND_MESSAGE_ID */], messageId);
        }
    }, {
        key: "getMessageId",
        value: function getMessageId() {
            var messageId = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["w" /* SEND_MESSAGE_ID */]);
            if (!messageId) {
                messageId = 0;
            }
            return messageId;
        }
    }, {
        key: "saveUserInfoList",
        value: function saveUserInfoList(value) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["A" /* USER_INFO_LIST */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
        }
    }, {
        key: "getUserInfoList",
        value: function getUserInfoList() {
            var value = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["A" /* USER_INFO_LIST */]);
            return JSON.parse(value);
        }
    }, {
        key: "saveMessages",
        value: function saveMessages(value) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["B" /* USER_MESSAGES */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
        }
    }, {
        key: "getMessages",
        value: function getMessages() {
            var value = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["B" /* USER_MESSAGES */]);
            return JSON.parse(value);
        }
    }, {
        key: "saveConverSations",
        value: function saveConverSations(value) {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["z" /* USER_CONVERSATIONS */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(value));
        }
    }, {
        key: "getConversations",
        value: function getConversations() {
            var vaule = localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["z" /* USER_CONVERSATIONS */]);
            return JSON.parse(vaule);
        }
    }, {
        key: "clearLocalStore",
        value: function clearLocalStore() {
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["z" /* USER_CONVERSATIONS */], "");
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["o" /* LAST_MESSAGE_SEQ */], "");
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["B" /* USER_MESSAGES */], "");
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["v" /* SEND_MESSAGE_COUNT */], 0);

            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["g" /* FRIEND_REQUEST_VERSION */], 0);
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["n" /* KEY_USER_ID */], '');
            localStorage.setItem(__WEBPACK_IMPORTED_MODULE_3__constant_system__["m" /* KEY_TOKEN */], "");
            this.setLastMessageSeq(0);
            this.saveUserInfoList("");
        }
    }]);

    return LocalStore;
}();

/* harmony default export */ __webpack_exports__["a"] = (LocalStore);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var StringUtils = function () {
    function StringUtils() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StringUtils);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(StringUtils, null, [{
        key: "b64_to_utf8",
        value: function b64_to_utf8(str) {
            return decodeURIComponent(escape(atob(str)));
        }
    }, {
        key: "utf8_to_b64",
        value: function utf8_to_b64(str) {
            return btoa(unescape(encodeURIComponent(str)));
        }
    }]);

    return StringUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (StringUtils);

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messageHandler__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_logger__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__future_futureResult__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant_system__ = __webpack_require__(10);










var AbstractMessageHandler = function (_MessageHandler) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AbstractMessageHandler, _MessageHandler);

    function AbstractMessageHandler(vueWebsocket) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AbstractMessageHandler);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AbstractMessageHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AbstractMessageHandler)).call(this));

        _this.vueWebsocket = vueWebsocket;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AbstractMessageHandler, [{
        key: "processMessage",
        value: function processMessage(proto) {
            __WEBPACK_IMPORTED_MODULE_6__utils_logger__["a" /* default */].log("AbstractMessageHandler messageId " + proto.messageId + " proto content " + proto.content);
            var promiseReslove = this.vueWebsocket.resolvePromiseMap.get(proto.messageId);
            if (promiseReslove) {
                clearTimeout(promiseReslove.timeoutId);
                if (proto.content == '') {
                    promiseReslove.resolve(new __WEBPACK_IMPORTED_MODULE_7__future_futureResult__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__constant_system__["e" /* ERROR_CODE */], proto.content));
                } else {
                    promiseReslove.resolve(new __WEBPACK_IMPORTED_MODULE_7__future_futureResult__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__constant_system__["x" /* SUCCESS_CODE */], this.notifyContent(proto.content)));
                }
                this.vueWebsocket.resolvePromiseMap.delete(proto.messageId);
            }
        }
    }, {
        key: "notifyContent",
        value: function notifyContent(content) {
            return content;
        }
    }, {
        key: "vueWebsocketClient",
        get: function get() {
            return this.vueWebsocket;
        }
    }]);

    return AbstractMessageHandler;
}(__WEBPACK_IMPORTED_MODULE_5__messageHandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AbstractMessageHandler);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messagePayload__ = __webpack_require__(114);




var MessageContent = function () {
    function MessageContent(type) {
        var mentionedType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var mentionedTargets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MessageContent);

        this.mentionedType = 0;
        this.mentionedTargets = [];

        this.type = type;
        this.mentionedType = mentionedType;
        this.mentionedTargets = mentionedTargets;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MessageContent, [{
        key: "digest",
        value: function digest() {
            return '...digest...';
        }
    }, {
        key: "encode",
        value: function encode() {
            var payload = new __WEBPACK_IMPORTED_MODULE_2__messagePayload__["a" /* default */]();
            payload.type = this.type;
            payload.mentionedType = this.mentionedType;
            payload.mentionedTargets = this.mentionedTargets;
            return payload;
        }
    }, {
        key: "decode",
        value: function decode(payload) {
            this.type = payload.type;
            this.mentionedType = payload.mentionedType;
            this.mentionedTargets = payload.mentionedTargets;
        }
    }]);

    return MessageContent;
}();

/* harmony default export */ __webpack_exports__["a"] = (MessageContent);

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export WebSocketClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex__ = __webpack_require__(39);




var WebSocketClient = function () {
   function WebSocketClient() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, WebSocketClient);
   }

   __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(WebSocketClient, [{
      key: 'getDisplayName',
      value: function getDisplayName(userId) {
         var userInfolist = __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.userInfoList;
         var userInfo = userInfolist.find(function (user) {
            return user.uid == userId;
         });
         var displayName = userId;
         if (userInfo) {
            displayName = userInfo.displayName;
            if (displayName == '') {
               displayName = userInfo.mobile;
            }
         } else {
            __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.getUserInfo(userId);
         }

         return displayName;
      }
   }, {
      key: 'getPortrait',
      value: function getPortrait(userId) {
         var userInfolist = __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.userInfoList;
         var userInfo = userInfolist.find(function (user) {
            return user.uid == userId;
         });
         var portrait = 'static/images/vue.jpg';
         if (userInfo) {
            portrait = userInfo.portrait;
         }
         return portrait;
      }
   }, {
      key: 'createGroup',
      value: function createGroup(groupName, memberIds) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.createGroup(groupName, memberIds);
      }
   }, {
      key: 'modifyGroupInfo',
      value: function modifyGroupInfo(info) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.modifyGroupInfo(info);
      }
   }, {
      key: 'quitGroup',
      value: function quitGroup(groupId) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.quitGroup(groupId);
      }
   }, {
      key: 'dismissGroup',
      value: function dismissGroup(groupId) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.dismissGroup(groupId);
      }
   }, {
      key: 'getGroupMember',
      value: function getGroupMember(groupId) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.getGroupMember(groupId);
      }
   }, {
      key: 'addMembers',
      value: function addMembers(groupId, memberIds) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.addMembers(groupId, memberIds);
      }
   }, {
      key: 'kickeMembers',
      value: function kickeMembers(groupId, memberIds) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.kickeMembers(groupId, memberIds);
      }
   }, {
      key: 'recallMessage',
      value: function recallMessage(messageUid) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.recallMessage(messageUid);
      }
   }, {
      key: 'getUploadToken',
      value: function getUploadToken(mediaType) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.getUploadToken(mediaType);
      }
   }, {
      key: 'getMinioUploadUrl',
      value: function getMinioUploadUrl(mediaType, key) {
         return __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */].state.vueSocket.getMinioUploadUrl(mediaType, key);
      }
   }]);

   return WebSocketClient;
}();

var self = new WebSocketClient();
/* harmony default export */ __webpack_exports__["a"] = (self);

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notificationMessageContent__ = __webpack_require__(56);






var GroupNotificationContent = function (_NotificationMessageC) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(GroupNotificationContent, _NotificationMessageC);

    function GroupNotificationContent() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GroupNotificationContent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GroupNotificationContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GroupNotificationContent)).call.apply(_ref, [this].concat(args))), _this), _this.groupId = '', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return GroupNotificationContent;
}(__WEBPACK_IMPORTED_MODULE_4__notificationMessageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GroupNotificationContent);

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fscommon_websocket__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fscommon_websocket_model_friendInfo__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fscommon_websocket_model_stateSelectChatMessage__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__fscommon_websocket_model_protoConversationInfo__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__fscommon_websocket_model_stateConversationInfo__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__fscommon_websocket_model_conversationType__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fscommon_websocket_model_unReadCount__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fscommon_constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fscommon_websocket_message_message__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fscommon_websocket_message_protomessage__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fscommon_websocket_message_messageConfig__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fscommon_websocket_message_notification_recallMessageNotification__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fscommon_websocket_message_protomessageContent__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fscommon_websocket_message_messageStatus__ = __webpack_require__(53);






















__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var state = {
    currentUser: null,
    userId: __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].getUserId(),
    token: __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].getToken(),
    vueSocket: null,
    friendIds: [],
    userInfoList: [],
    friendInfos: [],
    groupInfoList: [],
    selectFriendId: 0,

    selectTarget: '',
    firstLogin: false,

    conversations: [],

    messages: [],

    searchText: '',
    groupMemberMap: new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a(),
    groupMemberTracker: 0,
    selectGroupTargetForMoblie: ''
};

var mutations = {
    initData: function initData(state) {
        state.userId = __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].getUserId();
        state.token = __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].getToken();
        var vueSocket = new __WEBPACK_IMPORTED_MODULE_6__fscommon_websocket__["a" /* default */]();
        state.vueSocket = vueSocket;
        var conversations = __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].getConversations();
        if (conversations) {
            state.conversations = conversations;
        }
        var messages = __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].getMessages();
        if (messages) {
            state.messages = messages;
        }

        var userInfoList = __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].getUserInfoList();
        if (userInfoList) {
            state.userInfoList = userInfoList;
        }
    },
    updateFriendIds: function updateFriendIds(state, value) {
        if (value) {
            state.friendIds = value;
        }
    },
    updateUserInfos: function updateUserInfos(state, userInfos) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(userInfos), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var currentUserInfo = _step.value;

                if (currentUserInfo.uid === state.userId) {
                    state.currentUser = currentUserInfo;
                }
                var isExist = false;
                var deleteIndex = 0;
                for (var index in state.userInfoList) {
                    var userInfo = state.userInfoList[index];
                    if (userInfo.uid == currentUserInfo.uid) {
                        isExist = true;
                        deleteIndex = index;
                        break;
                    }
                }
                if (isExist) {
                    state.userInfoList.splice(deleteIndex, 1, currentUserInfo);
                } else {
                    state.userInfoList.push(currentUserInfo);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        this.commit("updateFriendInfos", userInfos);
    },
    updateFriendInfos: function updateFriendInfos(state, userInfos) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(userInfos), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var userInfo = _step2.value;

                var friendId = state.friendIds.find(function (friendId) {
                    return friendId == userInfo.uid;
                });
                if (friendId) {
                    var friendInfo = state.friendInfos.find(function (friendInfo) {
                        if (friendInfo) {
                            return friendInfo.title == userInfo.firstLetter;
                        } else {
                            return false;
                        }
                    });
                    if (friendInfo) {
                        friendInfo.updateUserInfo(userInfo);
                    } else {
                        friendInfo = __WEBPACK_IMPORTED_MODULE_8__fscommon_websocket_model_friendInfo__["a" /* default */].createFriendInfo(userInfo);
                        console.log("friend info " + friendInfo.title);

                        state.friendInfos.push(friendInfo);
                    }
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.conversations), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                var stateConversationInfo = _step3.value;

                var user = state.userInfoList.find(function (user) {
                    return user.uid === stateConversationInfo.conversationInfo.target;
                });
                if (user) {
                    stateConversationInfo.name = user.displayName;
                    stateConversationInfo.img = user.portrait;
                }
            }
        } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                }
            } finally {
                if (_didIteratorError3) {
                    throw _iteratorError3;
                }
            }
        }

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                var stateChatMessage = _step4.value;

                var user = state.userInfoList.find(function (user) {
                    return user.uid === stateChatMessage.target;
                });
                if (user) {
                    stateChatMessage.name = user.displayName;
                }
            }
        } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                }
            } finally {
                if (_didIteratorError4) {
                    throw _iteratorError4;
                }
            }
        }
    },
    selectFriend: function selectFriend(state, value) {
        console.log("selectFriend " + value);
        state.selectFriendId = value;
    },
    changetFirstLogin: function changetFirstLogin(state, value) {
        console.log("first login " + value);
        state.firstLogin = value;
    },
    addProtoMessage: function addProtoMessage(state, protoMessage) {
        var added = false;
        var isExistMessage = false;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var stateChatMessage = _step5.value;

                if (protoMessage.target == stateChatMessage.target) {
                    added = true;
                    var isSameProtoMessage = stateChatMessage.protoMessages.find(function (message) {
                        return message.messageId === protoMessage.messageId;
                    });
                    if (!isSameProtoMessage) {
                        stateChatMessage.protoMessages.push(protoMessage);
                    } else {
                        isExistMessage = true;
                    }
                }
            }
        } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                }
            } finally {
                if (_didIteratorError5) {
                    throw _iteratorError5;
                }
            }
        }

        if (!added) {
            var stateChatMessage = new __WEBPACK_IMPORTED_MODULE_9__fscommon_websocket_model_stateSelectChatMessage__["a" /* default */]();
            var user = state.userInfoList.find(function (user) {
                return user.uid === protoMessage.target;
            });
            if (user != null) {
                stateChatMessage.name = user.displayName;
            }
            stateChatMessage.target = protoMessage.target;
            stateChatMessage.protoMessages.push(protoMessage);
            state.messages.push(stateChatMessage);
        }

        if (!isExistMessage) {
            var protoConversationInfo = new __WEBPACK_IMPORTED_MODULE_10__fscommon_websocket_model_protoConversationInfo__["a" /* default */]();
            protoConversationInfo.conversationType = protoMessage.conversationType;
            protoConversationInfo.target = protoMessage.target;
            protoConversationInfo.line = 0;
            protoConversationInfo.top = false;
            protoConversationInfo.slient = false;
            protoConversationInfo.timestamp = protoMessage.timestamp;
            protoConversationInfo.lastMessage = protoMessage;
            protoConversationInfo.unreadCount = new __WEBPACK_IMPORTED_MODULE_13__fscommon_websocket_model_unReadCount__["a" /* default */]();

            this.commit('updateConversationInfo', protoConversationInfo);
        }
    },
    updateConversationInfo: function updateConversationInfo(state, protoConversationInfo) {
        var update = false;
        var updateStateConverstaionInfo;
        var currentConversationInfoIndex;
        for (var index in state.conversations) {
            var stateConverstaionInfo = state.conversations[index];
            if (stateConverstaionInfo.conversationInfo.conversationType == protoConversationInfo.conversationType && stateConverstaionInfo.conversationInfo.target == protoConversationInfo.target) {
                update = true;
                currentConversationInfoIndex = index;
                stateConverstaionInfo.conversationInfo.lastMessage = protoConversationInfo.lastMessage;
                stateConverstaionInfo.conversationInfo.timestamp = protoConversationInfo.lastMessage.timestamp;
                updateStateConverstaionInfo = stateConverstaionInfo;
                break;
            }
        }

        if (update) {
            state.conversations.splice(currentConversationInfoIndex, 1);
            state.conversations.unshift(updateStateConverstaionInfo);
        }
        if (!update) {
            updateStateConverstaionInfo = new __WEBPACK_IMPORTED_MODULE_11__fscommon_websocket_model_stateConversationInfo__["a" /* default */]();
            updateStateConverstaionInfo.conversationInfo = protoConversationInfo;

            if (protoConversationInfo.conversationType == __WEBPACK_IMPORTED_MODULE_12__fscommon_websocket_model_conversationType__["a" /* default */].Single) {
                var user = state.userInfoList.find(function (user) {
                    return user.uid === protoConversationInfo.target;
                });
                if (user != null) {
                    console.log("user " + user.displayName);

                    var name = user.displayName;
                    var img = user.portrait;
                    updateStateConverstaionInfo.name = name;
                    updateStateConverstaionInfo.img = img;
                } else {
                    updateStateConverstaionInfo.name = protoConversationInfo.target;
                    updateStateConverstaionInfo.img = __WEBPACK_IMPORTED_MODULE_14__fscommon_constant_system__["c" /* DEFACULT_VUE_IMG */];
                }
            } else {
                updateStateConverstaionInfo.name = protoConversationInfo.target;
                if (!updateStateConverstaionInfo.img) {
                    state.vueSocket.getGroupInfo(protoConversationInfo.target, false);
                }
                updateStateConverstaionInfo.img = __WEBPACK_IMPORTED_MODULE_14__fscommon_constant_system__["c" /* DEFACULT_VUE_IMG */];
            }
            state.conversations.push(updateStateConverstaionInfo);
        }

        var isCurrentConversationMessage = state.selectTarget === protoConversationInfo.target;

        var isShowSendingMessage = protoConversationInfo.lastMessage.direction === 1;

        if (!state.firstLogin && isShowSendingMessage && !isCurrentConversationMessage) {
            var num = updateStateConverstaionInfo.conversationInfo.unreadCount.unread += 1;
            var notifyBody = protoConversationInfo.lastMessage.content.searchableContent;
            console.log("target " + protoConversationInfo.target + " unread count " + num + " notify body " + notifyBody);
        }
    },
    updateGroupInfos: function updateGroupInfos(state, groupInfos) {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(groupInfos), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var currentGroupInfo = _step6.value;

                var isExist = false;
                var deleteIndex = 0;
                for (var index in state.groupInfoList) {
                    var groupInfo = state.groupInfoList[index];
                    if (groupInfo.target == currentGroupInfo.target) {
                        isExist = true;
                        deleteIndex = index;
                        break;
                    }
                }
                if (isExist) {
                    state.groupInfoList.splice(deleteIndex, 1, currentGroupInfo);
                } else {
                    state.groupInfoList.push(currentGroupInfo);
                }
            }
        } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                }
            } finally {
                if (_didIteratorError6) {
                    throw _iteratorError6;
                }
            }
        }

        console.log("group size " + state.groupInfoList.length);
        this.commit("updateConversationIntro", groupInfos);
    },
    updateConversationIntro: function updateConversationIntro(state, groupInfos) {
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(groupInfos), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                var groupInfo = _step7.value;

                var stateConverstaionInfo = state.conversations.find(function (stateConverstaionInfo) {
                    return stateConverstaionInfo.conversationInfo.target === groupInfo.target;
                });
                if (stateConverstaionInfo) {
                    console.log("update conversation name " + stateConverstaionInfo.name);
                    stateConverstaionInfo.name = groupInfo.name;
                    if (groupInfo.portrait) {
                        stateConverstaionInfo.img = groupInfo.portrait;
                    }
                }


                var stateChatMessage = state.messages.find(function (stateChatMessage) {
                    return stateChatMessage.target === groupInfo.target;
                });
                if (stateChatMessage) {
                    stateChatMessage.name = groupInfo.name + "(" + groupInfo.memberCount + ")";
                }
            }
        } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                }
            } finally {
                if (_didIteratorError7) {
                    throw _iteratorError7;
                }
            }
        }
    },
    getGroupInfo: function getGroupInfo(state, target) {
        state.vueSocket.getGroupInfo(target, false);
    },
    selectConversation: function selectConversation(state, value) {
        state.selectTarget = value;
        console.log("selectConversation target " + value);

        var stateConversationInfo = state.conversations.find(function (stateConversationInfo) {
            return stateConversationInfo.conversationInfo.target === value;
        });
        if (stateConversationInfo && stateConversationInfo.conversationInfo.unreadCount) {
            stateConversationInfo.conversationInfo.unreadCount.unread = 0;
        }
    },
    LOGOUT: function LOGOUT(state) {
        state.user = null;
        state.token = null;
        state.vueSocket.sendDisConnectMessage();
        state.vueSocket = null;
        state.friendIds = null;
        state.friendInfos = [];
        state.userInfoList = [];
        state.conversations = [];
        state.messages = [];
        state.selectFriendId = 0, state.selectTarget = '';
        state.firstLogin = false;
        state.isLogin = false;
        state.groupMemberTracker = 0;
        __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].clearLocalStore();
        __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push("/login");
    },
    sendMessage: function sendMessage(state, _sendMessage) {
        var message = __WEBPACK_IMPORTED_MODULE_15__fscommon_websocket_message_message__["a" /* default */].toMessage(state, _sendMessage);
        var protoMessage = __WEBPACK_IMPORTED_MODULE_16__fscommon_websocket_message_protomessage__["a" /* default */].convertToProtoMessage(message);
        console.log("send protomessage " + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(protoMessage));

        this.commit("preAddProtoMessage", protoMessage);

        state.vueSocket.sendMessage(protoMessage);
    },
    preAddProtoMessage: function preAddProtoMessage(state, protoMessage) {

        if (__WEBPACK_IMPORTED_MODULE_17__fscommon_websocket_message_messageConfig__["a" /* default */].isDisplayableMessage(protoMessage)) {
            var stateConversationInfo = state.conversations.find(function (stateConversationInfo) {
                return stateConversationInfo.conversationInfo.target === protoMessage.target;
            });
            stateConversationInfo.conversationInfo.lastMessage = protoMessage;
            stateConversationInfo.conversationInfo.timestamp = protoMessage.timestamp;

            var stateChatMessage = state.messages.find(function (chatmessage) {
                return chatmessage.target === protoMessage.target;
            });
            if (!stateChatMessage) {
                stateChatMessage = new __WEBPACK_IMPORTED_MODULE_9__fscommon_websocket_model_stateSelectChatMessage__["a" /* default */]();
                stateChatMessage.target = protoMessage.target;
                var friend = state.userInfoList.find(function (friend) {
                    return friend.uid === protoMessage.target;
                });
                if (friend != null) {
                    stateChatMessage.name = friend.displayName;
                }
                stateChatMessage.protoMessages.push(protoMessage);
                state.messages.push(stateChatMessage);
            } else {
                stateChatMessage.protoMessages.push(protoMessage);
            }
        }
    },
    updateSendMessage: function updateSendMessage(state, updateMessage) {
        var stateChatMessage = state.messages.find(function (stateChatMessage) {
            return stateChatMessage.target === state.selectTarget;
        });
        if (stateChatMessage) {
            var protoMessage = stateChatMessage.protoMessages.find(function (message) {
                return message.messageId == updateMessage.messageId;
            });
            if (protoMessage) {
                protoMessage.status = __WEBPACK_IMPORTED_MODULE_20__fscommon_websocket_message_messageStatus__["a" /* default */].Sending;
                var messagePayload = updateMessage.messageContent.encode();
                protoMessage.content = __WEBPACK_IMPORTED_MODULE_19__fscommon_websocket_message_protomessageContent__["a" /* default */].toProtoMessageContent(messagePayload);
            }
        }
        state.vueSocket.sendMessage(protoMessage);
    },
    send: function send(state) {
        var result = state.userInfoList.find(function (friend) {
            return friend.uid === state.selectFriendId;
        });
        var stateConversationInfo = state.conversations.find(function (stateConversationInfo) {
            return stateConversationInfo.conversationInfo.target === result.uid;
        });
        if (!stateConversationInfo) {
            state.selectTarget = result.uid;
            var protoConversationInfo = new __WEBPACK_IMPORTED_MODULE_10__fscommon_websocket_model_protoConversationInfo__["a" /* default */]();
            protoConversationInfo.conversationType = __WEBPACK_IMPORTED_MODULE_12__fscommon_websocket_model_conversationType__["a" /* default */].Single;
            protoConversationInfo.target = result.uid;
            protoConversationInfo.line = 0;
            protoConversationInfo.top = false;
            protoConversationInfo.slient = false;
            protoConversationInfo.timestamp = new Date().getTime();
            protoConversationInfo.unreadCount = new __WEBPACK_IMPORTED_MODULE_13__fscommon_websocket_model_unReadCount__["a" /* default */]();
            protoConversationInfo.lastMessage = null;

            var newStateConversationInfo = new __WEBPACK_IMPORTED_MODULE_11__fscommon_websocket_model_stateConversationInfo__["a" /* default */]();
            newStateConversationInfo.name = result.displayName;
            newStateConversationInfo.img = result.portrait;
            newStateConversationInfo.conversationInfo = protoConversationInfo;
            state.conversations.unshift(newStateConversationInfo);
        } else {
            state.selectTarget = stateConversationInfo.conversationInfo.target;
        }
        __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */].push({ path: "/chat/group-chat" });
    },
    deleteConversation: function deleteConversation(state, targetId) {
        var index = -1;
        for (var i = 0; i < state.conversations.length; i++) {
            if (state.conversations[i].conversationInfo.target == targetId) {
                index = i;
                break;
            }
        }
        console.log("quit group index " + index);
        if (index != -1) {
            state.conversations.splice(index, 1);
        }

        if (state.conversations.length > 0) {
            state.selectTarget = state.conversations[0].conversationInfo.target;
        }
    },
    updateProtoMessageUid: function updateProtoMessageUid(state, updateMessage) {
        var stateChatMessage = state.messages.find(function (stateChatMessage) {
            return stateChatMessage.target === state.selectTarget;
        });
        if (stateChatMessage) {
            var protoMessage = stateChatMessage.protoMessages.find(function (message) {
                return message.messageId == updateMessage.messageId;
            });
            if (protoMessage) {
                protoMessage.messageUid = updateMessage.messageUid;
                return;
            }
        }
        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                var stateChatMessage = _step8.value;
                var _iteratorNormalCompletion9 = true;
                var _didIteratorError9 = false;
                var _iteratorError9 = undefined;

                try {
                    for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(stateChatMessage.protoMessages), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                        var protoMessage = _step9.value;

                        if (protoMessage.messageId == updateMessage.messageId) {
                            protoMessage.messageUid = updateMessage.messageUid;
                        }
                    }
                } catch (err) {
                    _didIteratorError9 = true;
                    _iteratorError9 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion9 && _iterator9.return) {
                            _iterator9.return();
                        }
                    } finally {
                        if (_didIteratorError9) {
                            throw _iteratorError9;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                }
            } finally {
                if (_didIteratorError8) {
                    throw _iteratorError8;
                }
            }
        }
    },
    updateMessageStatus: function updateMessageStatus(state, _updateMessageStatus) {
        var stateChatMessage = state.messages.find(function (stateChatMessage) {
            return stateChatMessage.target === state.selectTarget;
        });
        if (stateChatMessage) {
            var protoMessage = stateChatMessage.protoMessages.find(function (message) {
                return message.messageId == _updateMessageStatus.messageId;
            });
            if (protoMessage) {
                protoMessage.status = _updateMessageStatus.status;
                return;
            }
        }
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
            for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
                var stateChatMessage = _step10.value;
                var _iteratorNormalCompletion11 = true;
                var _didIteratorError11 = false;
                var _iteratorError11 = undefined;

                try {
                    for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(stateChatMessage.protoMessages), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                        var protoMessage = _step11.value;

                        if (protoMessage.messageId == _updateMessageStatus.messageId) {
                            protoMessage.status = _updateMessageStatus.status;
                        }
                    }
                } catch (err) {
                    _didIteratorError11 = true;
                    _iteratorError11 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion11 && _iterator11.return) {
                            _iterator11.return();
                        }
                    } finally {
                        if (_didIteratorError11) {
                            throw _iteratorError11;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError10 = true;
            _iteratorError10 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion10 && _iterator10.return) {
                    _iterator10.return();
                }
            } finally {
                if (_didIteratorError10) {
                    throw _iteratorError10;
                }
            }
        }
    },
    updateRecallMessageContent: function updateRecallMessageContent(state, notifyMessage) {
        var found = false;
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
            for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.messages), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var stateMessages = _step12.value;
                var _iteratorNormalCompletion13 = true;
                var _didIteratorError13 = false;
                var _iteratorError13 = undefined;

                try {
                    for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(stateMessages.protoMessages), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                        var protoMessage = _step13.value;

                        if (protoMessage.messageUid == notifyMessage.messageUid) {
                            var recallMessageContent = new __WEBPACK_IMPORTED_MODULE_18__fscommon_websocket_message_notification_recallMessageNotification__["a" /* default */](notifyMessage.fromUser, notifyMessage.messageUid);
                            protoMessage.content = recallMessageContent.encode();
                            found = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError13 = true;
                    _iteratorError13 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion13 && _iterator13.return) {
                            _iterator13.return();
                        }
                    } finally {
                        if (_didIteratorError13) {
                            throw _iteratorError13;
                        }
                    }
                }

                if (found) {
                    break;
                }
            }
        } catch (err) {
            _didIteratorError12 = true;
            _iteratorError12 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                    _iterator12.return();
                }
            } finally {
                if (_didIteratorError12) {
                    throw _iteratorError12;
                }
            }
        }
    }
};

var getters = {
    selectedFriend: function selectedFriend(state) {
        console.log("friend " + state.userInfoList.length);
        var friend = state.userInfoList.find(function (friend) {
            return friend.uid === state.selectFriendId;
        });
        return friend;
    },
    searchedConversationList: function searchedConversationList() {
        return state.conversations.filter(function (conversationInfo) {
            return conversationInfo.name ? conversationInfo.name.includes(state.searchText) : false;
        });
    },
    selectedChat: function selectedChat(state) {
        var chatMessage = state.messages.find(function (chatMessage) {
            return chatMessage.target === state.selectTarget;
        });
        console.log("select target " + state.selectTarget);
        if (chatMessage == null) {
            var conversationName = "";
            var conversationTarget = '';
            if (state.userInfoList) {
                var friend = state.userInfoList.find(function (friend) {
                    return friend.uid == state.selectTarget;
                });
                if (friend) {
                    conversationName = friend.displayName;
                    conversationTarget = friend.uid;
                }
            }
            chatMessage = {
                name: conversationName,
                target: conversationTarget,
                protoMessages: []
            };
        }
        console.log("selectedChat " + chatMessage.name + " target " + chatMessage.target);
        return chatMessage;
    },
    isSingleConversation: function isSingleConversation() {
        var stateConversation = state.conversations.find(function (stateConversation) {
            return stateConversation.conversationInfo.target === state.selectTarget;
        });
        if (!stateConversation) {
            return false;
        }
        return stateConversation.conversationInfo.conversationType === __WEBPACK_IMPORTED_MODULE_12__fscommon_websocket_model_conversationType__["a" /* default */].Single;
    },
    messages: function messages(state) {
        var chatMessage = state.messages.find(function (chatMessage) {
            return chatMessage.target === state.selectTarget;
        });
        if (chatMessage == null) {
            return [];
        }
        return chatMessage.protoMessages;
    },
    unreadTotalCount: function unreadTotalCount(state) {
        var total = 0;
        if (state.conversations) {
            var _iteratorNormalCompletion14 = true;
            var _didIteratorError14 = false;
            var _iteratorError14 = undefined;

            try {
                for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(state.conversations), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
                    var stateConversationInfo = _step14.value;

                    if (stateConversationInfo.conversationInfo.unreadCount) {
                        total += stateConversationInfo.conversationInfo.unreadCount.unread;
                    }
                }
            } catch (err) {
                _didIteratorError14 = true;
                _iteratorError14 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
                        _iterator14.return();
                    }
                } finally {
                    if (_didIteratorError14) {
                        throw _iteratorError14;
                    }
                }
            }
        }
        return total;
    }
};

var actions = {
    initData: function initData(_ref) {
        var commit = _ref.commit;
        return commit('initData');
    },
    updateFriendIds: function updateFriendIds(_ref2, value) {
        var commit = _ref2.commit;
        return commit('updateFriendIds', value);
    },
    updateUserInfos: function updateUserInfos(_ref3, value) {
        var commit = _ref3.commit;
        return commit('updateUserInfos', value);
    },
    selectFriend: function selectFriend(_ref4, value) {
        var commit = _ref4.commit;
        return commit('selectFriend', value);
    },
    changetFirstLogin: function changetFirstLogin(_ref5, value) {
        var commit = _ref5.commit;
        return commit('changetFirstLogin', value);
    },
    addProtoMessage: function addProtoMessage(_ref6, value) {
        var commit = _ref6.commit;
        return commit('addProtoMessage', value);
    },
    updateGroupInfos: function updateGroupInfos(_ref7, value) {
        var commit = _ref7.commit;
        return commit('updateGroupInfos', value);
    },
    selectConversation: function selectConversation(_ref8, value) {
        var commit = _ref8.commit;
        return commit('selectConversation', value);
    },
    sendMessage: function sendMessage(_ref9, msg) {
        var commit = _ref9.commit;
        return commit('sendMessage', msg);
    },
    send: function send(_ref10) {
        var commit = _ref10.commit;
        return commit('send');
    },
    deleteConversation: function deleteConversation(_ref11, value) {
        var commit = _ref11.commit;
        return commit('deleteConversation', value);
    },
    getGroupInfo: function getGroupInfo(_ref12, value) {
        var commit = _ref12.commit;
        return commit('getGroupInfo', value);
    },
    updateProtoMessageUid: function updateProtoMessageUid(_ref13, value) {
        var commit = _ref13.commit;
        return commit('updateProtoMessageUid', value);
    },
    updateMessageStatus: function updateMessageStatus(_ref14, value) {
        var commit = _ref14.commit;
        return commit('updateMessageStatus', value);
    },
    updateRecallMessageContent: function updateRecallMessageContent(_ref15, value) {
        var commit = _ref15.commit;
        return commit('updateRecallMessageContent', value);
    },
    preAddProtoMessage: function preAddProtoMessage(_ref16, value) {
        var commit = _ref16.commit;
        return commit('preAddProtoMessage', value);
    },
    updateSendMessage: function updateSendMessage(_ref17, value) {
        var commit = _ref17.commit;
        return commit('updateSendMessage', value);
    }
};

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
});

store.watch(function (state) {
    return state.conversations;
}, function (value) {
    __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].saveConverSations(value);
}, {
    deep: true
});

store.watch(function (state) {
    return state.messages;
}, function (value) {
    __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].saveMessages(value);
}, {
    deep: true
});

store.watch(function (state) {
    return state.userInfoList;
}, function (value) {
    __WEBPACK_IMPORTED_MODULE_5__fscommon_utils_localstore__["a" /* default */].saveUserInfoList(value);
}, {
    deep: true
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var MessageStatus = function MessageStatus() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MessageStatus);
};

MessageStatus.Sending = 0;
MessageStatus.Sent = 1;
MessageStatus.SendFailure = 2;
MessageStatus.Mentioned = 3;
MessageStatus.AllMentioned = 4;
MessageStatus.Unread = 5;
MessageStatus.Readed = 6;
MessageStatus.Played = 7;
/* harmony default export */ __webpack_exports__["a"] = (MessageStatus);

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messageContent__ = __webpack_require__(20);







var NotificationMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NotificationMessageContent, _MessageContent);

    function NotificationMessageContent(type) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NotificationMessageContent);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotificationMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(NotificationMessageContent)).call(this, type));

        _this.fromSelf = false;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NotificationMessageContent, [{
        key: 'digest',
        value: function digest(message) {
            var desc = '';
            try {
                desc = this.formatNotification(message);
            } catch (error) {
                console.log('disgest', error);
            }
            return desc;
        }
    }, {
        key: 'formatNotification',
        value: function formatNotification(message) {
            return '..nofication..';
        }
    }]);

    return NotificationMessageContent;
}(__WEBPACK_IMPORTED_MODULE_5__messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NotificationMessageContent);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var ConversationType = function ConversationType() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ConversationType);
};

ConversationType.Single = 0;
ConversationType.Group = 1;
ConversationType.ChatRoom = 2;
ConversationType.Channel = 3;
/* harmony default export */ __webpack_exports__["a"] = (ConversationType);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var MessageContentMediaType = function MessageContentMediaType() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MessageContentMediaType);
};

MessageContentMediaType.General = 0;
MessageContentMediaType.Image = 1;
MessageContentMediaType.Voice = 2;
MessageContentMediaType.Video = 3;
MessageContentMediaType.File = 4;
MessageContentMediaType.Portrait = 5;
MessageContentMediaType.Fvaorite = 6;
/* harmony default export */ __webpack_exports__["a"] = (MessageContentMediaType);

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messageContent__ = __webpack_require__(20);








var MediaMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(MediaMessageContent, _MessageContent);

    function MediaMessageContent(messageType) {
        var mediaType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var fileOrLocalPath = arguments[2];
        var remotePath = arguments[3];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MediaMessageContent);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MediaMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MediaMessageContent)).call(this, messageType));

        _this.remotePath = '';
        _this.localPath = '';
        _this.mediaType = 0;

        _this.mediaType = mediaType;
        if (typeof fileOrLocalPath === "string") {
            _this.localPath = fileOrLocalPath;
            _this.remotePath = remotePath;
        } else {
            _this.file = fileOrLocalPath;
            if (fileOrLocalPath && fileOrLocalPath.path !== undefined) {
                _this.localPath = fileOrLocalPath.path;

                if (_this.localPath.indexOf(fileOrLocalPath.name) < 0) {
                    _this.localPath += fileOrLocalPath.name;
                }
            }
        }
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MediaMessageContent, [{
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(MediaMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MediaMessageContent.prototype), 'encode', this).call(this);
            payload.localMediaPath = this.localPath;
            payload.remoteMediaUrl = this.remotePath;
            payload.mediaType = this.mediaType;
            payload.searchableContent = this.digest();
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(MediaMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MediaMessageContent.prototype), 'decode', this).call(this, payload);
            this.localPath = payload.localMediaPath;
            this.remotePath = payload.remoteMediaUrl;
            this.mediaType = payload.mediaType;
        }
    }]);

    return MediaMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MediaMessageContent);

/***/ }),
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__persistFlag__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__unknownMessageContent__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__textMessageContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__unsupportMessageContent__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__webrtc_message_callStartMessageContent__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__webrtc_message_callAnswerMessageContent__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__webrtc_message_callAnswerTMessageContent__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__webrtc_message_callSignalMessageContent__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__imageMessageContent__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__webrtc_message_callByeMessageContent__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__webrtc_message_callModifyMessageContent__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__notification_createGroupNotification__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__notification_changeGroupNameNotification__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__notification_notificationMessageContent__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__notification_addGroupMemberNotification__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__notification_quitGroupNotification__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__notification_recallMessageNotification__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__notification_kickoffGroupMemberNotification__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__notification_dismissGroupNotification__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_localstore__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__videoMessageContent__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__soundMessageContent__ = __webpack_require__(124);



























var MessageConfig = function () {
    function MessageConfig() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MessageConfig);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MessageConfig, null, [{
        key: 'getMessageContentClazz',
        value: function getMessageContentClazz(type) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(MessageConfig.MessageContents), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var content = _step.value;

                    if (content.type === type) {
                        if (content.contentClazz) {
                            return content.contentClazz;
                        } else {
                            return __WEBPACK_IMPORTED_MODULE_7__unsupportMessageContent__["a" /* default */];
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            console.log('message type ' + type + ' is unknown');
            return __WEBPACK_IMPORTED_MODULE_4__unknownMessageContent__["a" /* default */];
        }
    }, {
        key: 'convert2MessageContent',
        value: function convert2MessageContent(from, protoMessageContent) {
            var messageContent = null;
            var contentClazz = this.getMessageContentClazz(protoMessageContent.type);
            if (contentClazz != __WEBPACK_IMPORTED_MODULE_7__unsupportMessageContent__["a" /* default */]) {
                var content = new contentClazz();
                try {
                    content.decode(protoMessageContent);
                    if (content instanceof __WEBPACK_IMPORTED_MODULE_17__notification_notificationMessageContent__["a" /* default */]) {
                        content.fromSelf = from === __WEBPACK_IMPORTED_MODULE_23__utils_localstore__["a" /* default */].getUserId();
                    }
                    messageContent = content;
                } catch (error) {
                    console.log("decode message content error " + protoMessageContent);
                }
            }
            return messageContent;
        }
    }, {
        key: 'getMessageContentPersitFlag',
        value: function getMessageContentPersitFlag(type) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(MessageConfig.MessageContents), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var content = _step2.value;

                    if (content.type === type) {
                        return content.flag;
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return 0;
        }
    }, {
        key: 'isDisplayableMessage',
        value: function isDisplayableMessage(protomessage) {
            var messageContent = protomessage.content;
            if (MessageConfig.getMessageContentPersitFlag(messageContent.type) == __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist || MessageConfig.getMessageContentPersitFlag(messageContent.type) == __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count) {
                return true;
            }
            return false;
        }
    }]);

    return MessageConfig;
}();

MessageConfig.MessageContents = [{
    name: 'unknown',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Unknown,
    contentClazz: __WEBPACK_IMPORTED_MODULE_4__unknownMessageContent__["a" /* default */]
}, {
    name: 'text',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Text,
    contentClazz: __WEBPACK_IMPORTED_MODULE_6__textMessageContent__["a" /* default */]
}, {
    name: 'ptext',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].P_Text
}, {
    name: 'voice',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Voice,
    contentClazz: __WEBPACK_IMPORTED_MODULE_25__soundMessageContent__["a" /* default */]
}, {
    name: 'image',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Image,
    contentClazz: __WEBPACK_IMPORTED_MODULE_12__imageMessageContent__["a" /* default */]
}, {
    name: 'location',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Location
}, {
    name: 'file',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].File
}, {
    name: 'video',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Video,
    contentClazz: __WEBPACK_IMPORTED_MODULE_24__videoMessageContent__["a" /* default */]
}, {
    name: 'sticker',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Sticker
}, {
    name: 'imageText',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist_And_Count,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].ImageText
}, {
    name: 'tip',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Tip_Notification
}, {
    name: 'typing',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Transparent,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].Typing
}, {
    name: 'addGroupMemberNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].AddGroupMember_Notification,
    contentClazz: __WEBPACK_IMPORTED_MODULE_18__notification_addGroupMemberNotification__["a" /* default */]
}, {
    name: 'changeGroupNameNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].ChangeGroupName_Notification,
    contentClazz: __WEBPACK_IMPORTED_MODULE_16__notification_changeGroupNameNotification__["a" /* default */]
}, {
    name: 'changeGroupPortraitNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].ChangeGroupPortrait_Notification
}, {
    name: 'createGroupNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].CreateGroup_Notification,
    contentClazz: __WEBPACK_IMPORTED_MODULE_15__notification_createGroupNotification__["a" /* default */]
}, {
    name: 'dismissGroupNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].DismissGroup_Notification,
    contentClazz: __WEBPACK_IMPORTED_MODULE_22__notification_dismissGroupNotification__["a" /* default */]
}, {
    name: 'kickoffGroupMemberNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].KickOffGroupMember_Notification,
    contentClazz: __WEBPACK_IMPORTED_MODULE_21__notification_kickoffGroupMemberNotification__["a" /* default */]
}, {
    name: 'modifyGroupAliasNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].ModifyGroupAlias_Notification
}, {
    name: 'quitGroupNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].QuitGroup_Notification,
    contentClazz: __WEBPACK_IMPORTED_MODULE_19__notification_quitGroupNotification__["a" /* default */]
}, {
    name: 'transferGroupOwnerNotification',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].TransferGroupOwner_Notification
}, {
    name: 'recall',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].RecallMessage_Notification,
    contentClazz: __WEBPACK_IMPORTED_MODULE_20__notification_recallMessageNotification__["a" /* default */]
}, {
    name: 'callStartMessageContent',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_START,
    contentClazz: __WEBPACK_IMPORTED_MODULE_8__webrtc_message_callStartMessageContent__["a" /* default */]
}, {
    name: 'callAnswerMessageContent',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].No_Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_ACCEPT,
    contentClazz: __WEBPACK_IMPORTED_MODULE_9__webrtc_message_callAnswerMessageContent__["a" /* default */]
}, {
    name: 'callAnswerTMessageContent',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Transparent,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_ACCEPT_T,
    contentClazz: __WEBPACK_IMPORTED_MODULE_10__webrtc_message_callAnswerTMessageContent__["a" /* default */]
}, {
    name: 'callByeMessageContent',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].No_Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_END,
    contentClazz: __WEBPACK_IMPORTED_MODULE_13__webrtc_message_callByeMessageContent__["a" /* default */]
}, {
    name: 'callSignalMessageContent',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Transparent,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_SIGNAL,
    contentClazz: __WEBPACK_IMPORTED_MODULE_11__webrtc_message_callSignalMessageContent__["a" /* default */]
}, {
    name: 'callModifyMessageContent',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].No_Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_MODIFY,
    contentClazz: __WEBPACK_IMPORTED_MODULE_14__webrtc_message_callModifyMessageContent__["a" /* default */]
}, {
    name: 'callAddParticipant',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_ADD_PARTICIPANT
}, {
    name: 'callMuteVideo',
    flag: __WEBPACK_IMPORTED_MODULE_3__persistFlag__["a" /* default */].No_Persist,
    type: __WEBPACK_IMPORTED_MODULE_5__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_MUTE_VIDEO
}];
/* harmony default export */ __webpack_exports__["a"] = (MessageConfig);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messageStatus__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_conversationType__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__protomessageContent__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_localstore__ = __webpack_require__(14);







var ProtoMessage = function () {
    function ProtoMessage() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ProtoMessage);

        this.from = '';
        this.content = {};
        this.messageId = 0;
        this.direction = 0;
        this.status = 0;
        this.messageUid = 0;
        this.timestamp = 0;
        this.to = '';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ProtoMessage, null, [{
        key: "toProtoMessage",
        value: function toProtoMessage(obj) {
            var currentUserId = __WEBPACK_IMPORTED_MODULE_5__utils_localstore__["a" /* default */].getUserId();
            var protoMessage = new ProtoMessage();
            if (obj.from == currentUserId) {
                protoMessage.direction = 0;
                protoMessage.status = __WEBPACK_IMPORTED_MODULE_2__messageStatus__["a" /* default */].Sent;
            } else {
                protoMessage.direction = 1;
                protoMessage.status = __WEBPACK_IMPORTED_MODULE_2__messageStatus__["a" /* default */].Unread;
            }
            protoMessage.messageId = obj.messageId;
            protoMessage.messageUid = obj.messageId;
            protoMessage.timestamp = obj.timestamp;
            protoMessage.conversationType = obj.conversationType;
            protoMessage.target = obj.target;
            protoMessage.from = obj.from;
            if (protoMessage.conversationType == __WEBPACK_IMPORTED_MODULE_3__model_conversationType__["a" /* default */].Single) {
                if (obj.from != currentUserId) {
                    protoMessage.target = obj.from;
                    protoMessage.from = obj.from;
                } else {
                    protoMessage.target = obj.target;
                    protoMessage.from = obj.from;
                }
            }
            protoMessage.line = obj.line;
            protoMessage.content = __WEBPACK_IMPORTED_MODULE_4__protomessageContent__["a" /* default */].toProtoMessageContent(obj.content);
            return protoMessage;
        }
    }, {
        key: "convertToProtoMessage",
        value: function convertToProtoMessage(message) {
            var protoMessage = new ProtoMessage();
            protoMessage.conversationType = message.conversation.type;
            protoMessage.target = message.conversation.target;
            protoMessage.line = message.conversation.line;
            protoMessage.from = message.from;
            protoMessage.direction = message.direction;
            protoMessage.status = message.status;
            protoMessage.messageId = message.messageId;
            protoMessage.messageUid = message.messageUid;
            protoMessage.timestamp = message.timestamp;
            var payload = message.content.encode();
            protoMessage.content = __WEBPACK_IMPORTED_MODULE_4__protomessageContent__["a" /* default */].toProtoMessageContent(payload);
            return protoMessage;
        }
    }]);

    return ProtoMessage;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProtoMessage);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fscommon_utils_localstore__ = __webpack_require__(14);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  created: function created() {
    console.log("app created");
  },
  mounted: function mounted() {
    console.log("app mounted");
    if (__WEBPACK_IMPORTED_MODULE_4__fscommon_utils_localstore__["a" /* default */].isLogin()) {
      this.$store.dispatch("initData");
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapState */])([])),
  data: function data() {
    return { isTopFixed: true };
  },

  components: { headerBar: __WEBPACK_IMPORTED_MODULE_1__components_header__["a" /* default */], tabBar: __WEBPACK_IMPORTED_MODULE_2__components_footer__["a" /* default */] }
});

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(55);




/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapState */])([]), Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["unreadTotalCount"])),
  data: function data() {
    return {};
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fscommon_utils_localstore__ = __webpack_require__(14);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{ path: '/login', component: function component(resolve) {
            return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(289)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { path: '/register', component: function component(resolve) {
            return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(290)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { path: '/', component: function component(resolve) {
            return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(291)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { showHeader: true, showTabBar: true, requireAuth: true }
    }, { path: '/contact', component: function component(resolve) {
            return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(292)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { showHeader: true, showTabBar: true, requireAuth: true }
    }, { path: '/contact/uinfo', component: function component(resolve) {
            return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(293)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { path: '/ucenter', component: function component(resolve) {
            return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(294)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { showHeader: true, showTabBar: true, requireAuth: true }
    }, { path: '/chat/group-chat', component: function component(resolve) {
            return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(295)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requireAuth: true }
    }, { path: '/chat/single-chat', component: function component(resolve) {
            return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(296)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requireAuth: true }
    }, { path: '/chat/group-info', component: function component(resolve) {
            return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(297)]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requireAuth: true }
    }]
});

var whiteList = ['/login'];
router.beforeEach(function (to, from, next) {
    var token = __WEBPACK_IMPORTED_MODULE_3__fscommon_utils_localstore__["a" /* default */].getToken();
    console.log('match route token ' + token + " to " + to.path + " from " + from.path + " next " + next.path);
    if (token) {
        if (to.path === '/login') {
            next({ path: '/' });
        } else {
            next();
        }
    } else {
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next('/login');
        }
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var FutureResult = function FutureResult(code, result) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FutureResult);

    this.code = code;
    this.result = result;
};

/* harmony default export */ __webpack_exports__["a"] = (FutureResult);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messageContentType__ = __webpack_require__(7);




var ProtoMessageContent = function () {
    function ProtoMessageContent() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ProtoMessageContent);

        this.mentionedType = 0;
        this.mentionedTargets = [];
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ProtoMessageContent, null, [{
        key: "toProtoMessageContent",
        value: function toProtoMessageContent(content) {
            var protoMessageContent = new ProtoMessageContent();
            protoMessageContent.type = content.type;
            protoMessageContent.content = content.content;
            protoMessageContent.searchableContent = content.searchableContent;
            protoMessageContent.pushContent = content.pushContent;
            protoMessageContent.binaryContent = content.binaryContent;
            protoMessageContent.localContent = content.localContent;
            protoMessageContent.mediaType = content.mediaType;
            protoMessageContent.remoteMediaUrl = content.remoteMediaUrl;
            protoMessageContent.localMediaPath = content.localMediaPath;
            protoMessageContent.mentionedType = content.mentionedType;
            protoMessageContent.mentionedTargets = content.mentionedTargets;
            return protoMessageContent;
        }
    }, {
        key: "typeToContent",
        value: function typeToContent(messageContent) {
            var showText = "您有新的消息";
            switch (messageContent.type) {
                case __WEBPACK_IMPORTED_MODULE_2__messageContentType__["a" /* default */].Image:
                    showText = "[图片]";
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__messageContentType__["a" /* default */].File:
                    showText = "[文件]";
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__messageContentType__["a" /* default */].Video:
                    showText = "[视频]";
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_START:
                    showText = "[网络电话]";
                    break;
                case __WEBPACK_IMPORTED_MODULE_2__messageContentType__["a" /* default */].Tip_Notification:
                    showText = '[通知消息]';
            }
            return showText;
        }
    }]);

    return ProtoMessageContent;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProtoMessageContent);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var MessagePayload = function MessagePayload() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MessagePayload);

    this.mentionedType = 0;
    this.mentionedTargets = [];
};

/* harmony default export */ __webpack_exports__["a"] = (MessagePayload);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notificationMessageContent__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__websocketcli__ = __webpack_require__(25);











var RecallMessageNotification = function (_NotificationMessageC) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RecallMessageNotification, _NotificationMessageC);

    function RecallMessageNotification(operatorId, messageUid) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RecallMessageNotification);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RecallMessageNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RecallMessageNotification)).call(this, __WEBPACK_IMPORTED_MODULE_7__messageContentType__["a" /* default */].RecallMessage_Notification));

        _this.operatorId = '';
        _this.messageUid = '';

        _this.operatorId = operatorId;
        _this.messageUid = messageUid;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RecallMessageNotification, [{
        key: 'formatNotification',
        value: function formatNotification() {
            if (this.fromSelf) {
                return "您撤回了一条消息";
            } else {
                return __WEBPACK_IMPORTED_MODULE_9__websocketcli__["a" /* default */].getDisplayName(this.operatorId) + "撤回了一条消息";
            }
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(RecallMessageNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RecallMessageNotification.prototype), 'encode', this).call(this);
            payload.content = this.operatorId;
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].utf8_to_b64(this.messageUid.toString());
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(RecallMessageNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RecallMessageNotification.prototype), 'decode', this).call(this, payload);
            this.operatorId = payload.content;
            this.messageUid = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
        }
    }]);

    return RecallMessageNotification;
}(__WEBPACK_IMPORTED_MODULE_6__notificationMessageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (RecallMessageNotification);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var UnreadCount = function UnreadCount() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UnreadCount);

    this.unread = 0;
    this.unreadMention = 0;
    this.unreadMentionAll = 0;
};

/* harmony default export */ __webpack_exports__["a"] = (UnreadCount);

/***/ }),
/* 117 */,
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return WS_PROTOCOL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return WS_IP; });
/* unused harmony export HTTP_IP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WS_PORT; });
/* unused harmony export HTTP_HOST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOGIN_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SNED_VERIFY_CODE_API; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HEART_BEAT_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECONNECT_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BINTRAY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPLOAD_BY_QINIU; });
var WS_PROTOCOL = 'wss';
var WS_IP = 'backend-websocket.fsharechat.cn/ws';
var HTTP_IP = 'backend-http.fsharechat.cn';

var WS_PORT = 9326;
var HTTP_HOST = "https://" + HTTP_IP + "/";
var LOGIN_API = HTTP_HOST + "login";
var SNED_VERIFY_CODE_API = HTTP_HOST + "send_code";;
var HEART_BEAT_INTERVAL = 25 * 1000;
var RECONNECT_INTERVAL = 30 * 1000;
var BINTRAY_TYPE = 'blob';

var UPLOAD_BY_QINIU = false;

/***/ }),
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messageContent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messagePayload__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messageContentType__ = __webpack_require__(7);










var TextMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TextMessageContent, _MessageContent);

    function TextMessageContent(content) {
        var mentionedType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var mentionedTargets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TextMessageContent);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TextMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TextMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_8__messageContentType__["a" /* default */].Text, mentionedType, mentionedTargets));

        _this.content = content;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TextMessageContent, [{
        key: 'digest',
        value: function digest() {
            return this.content;
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(TextMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TextMessageContent.prototype), 'encode', this).call(this);
            payload.searchableContent = this.content;
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(TextMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TextMessageContent.prototype), 'decode', this).call(this, payload);
            this.content = payload.searchableContent;
        }
    }]);

    return TextMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (TextMessageContent);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__websocket_message_messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__ = __webpack_require__(15);











var CallStartMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(CallStartMessageContent, _MessageContent);

    function CallStartMessageContent(callId, targetId, audioOnly) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CallStartMessageContent);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CallStartMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CallStartMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_8__websocket_message_messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_START));

        _this.callId = callId;
        _this.targetId = targetId;
        _this.audioOnly = audioOnly;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CallStartMessageContent, [{
        key: 'digest',
        value: function digest() {
            if (this.audioOnly) {
                return '[语音通话]';
            } else {
                return '[视频通话]';
            }
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(CallStartMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CallStartMessageContent.prototype), 'encode', this).call(this);
            payload.content = this.callId;

            var obj = {
                c: this.connectTime,
                e: this.endTime,
                s: this.status,
                a: this.audioOnly ? 1 : 0,
                t: this.targetId
            };
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].utf8_to_b64(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(CallStartMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CallStartMessageContent.prototype), 'decode', this).call(this, payload);
            this.callId = payload.content;
            var json = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
            var obj = JSON.parse(json);

            this.connectTime = obj.c;
            this.endTime = obj.e;
            this.status = obj.s;
            this.audioOnly = obj.a === 1;
            this.targetId = obj.t;
        }
    }]);

    return CallStartMessageContent;
}(__WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CallStartMessageContent);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mediaMessageContent__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentMediaType__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messageContentType__ = __webpack_require__(7);










var ImageMessageContent = function (_MediaMessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ImageMessageContent, _MediaMessageContent);

    function ImageMessageContent(fileOrLocalPath, remotePath, thumbnail) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImageMessageContent);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ImageMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ImageMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_8__messageContentType__["a" /* default */].Image, __WEBPACK_IMPORTED_MODULE_7__messageContentMediaType__["a" /* default */].Image, fileOrLocalPath, remotePath));

        _this.thumbnail = thumbnail;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ImageMessageContent, [{
        key: 'digest',
        value: function digest() {
            return '[图片]';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(ImageMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ImageMessageContent.prototype), 'encode', this).call(this);
            payload.mediaType = __WEBPACK_IMPORTED_MODULE_7__messageContentMediaType__["a" /* default */].Image;
            payload.binaryContent = this.thumbnail;
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(ImageMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ImageMessageContent.prototype), 'decode', this).call(this, payload);
            this.thumbnail = payload.binaryContent;
        }
    }]);

    return ImageMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__mediaMessageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ImageMessageContent);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mediaMessageContent__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentMediaType__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messageContentType__ = __webpack_require__(7);










var VideoMessageContent = function (_MediaMessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(VideoMessageContent, _MediaMessageContent);

    function VideoMessageContent(fileOrLocalPath, remotePath, thumbnail) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, VideoMessageContent);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (VideoMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(VideoMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_8__messageContentType__["a" /* default */].Video, __WEBPACK_IMPORTED_MODULE_7__messageContentMediaType__["a" /* default */].Video, fileOrLocalPath, remotePath));

        _this.thumbnail = thumbnail;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(VideoMessageContent, [{
        key: 'digest',
        value: function digest() {
            return '[视频]';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(VideoMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(VideoMessageContent.prototype), 'encode', this).call(this);
            payload.binaryContent = this.thumbnail;
            payload.mediaType = __WEBPACK_IMPORTED_MODULE_7__messageContentMediaType__["a" /* default */].Video;
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(VideoMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(VideoMessageContent.prototype), 'decode', this).call(this, payload);
            this.thumbnail = payload.binaryContent;
        }
    }]);

    return VideoMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__mediaMessageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (VideoMessageContent);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mediaMessageContent__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__messageContentMediaType__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__messageContentType__ = __webpack_require__(7);











var SoundMessageContent = function (_MediaMessageContent) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(SoundMessageContent, _MediaMessageContent);

    function SoundMessageContent(fileOrLocalPath, remotePath, duration) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SoundMessageContent);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SoundMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SoundMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_9__messageContentType__["a" /* default */].Voice, __WEBPACK_IMPORTED_MODULE_8__messageContentMediaType__["a" /* default */].Voice, fileOrLocalPath, remotePath));

        _this.duration = duration;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SoundMessageContent, [{
        key: 'digest',
        value: function digest() {
            return '[语音]';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(SoundMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SoundMessageContent.prototype), 'encode', this).call(this);
            payload.mediaType = __WEBPACK_IMPORTED_MODULE_8__messageContentMediaType__["a" /* default */].Voice;
            var obj = {
                duration: this.duration
            };
            payload.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj);
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(SoundMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SoundMessageContent.prototype), 'decode', this).call(this, payload);
            var obj = JSON.parse(payload.content);
            this.duration = obj.duration;
        }
    }]);

    return SoundMessageContent;
}(__WEBPACK_IMPORTED_MODULE_7__mediaMessageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SoundMessageContent);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_conversation__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messageStatus__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_localstore__ = __webpack_require__(14);







var Message = function () {
    function Message() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Message);

        this.conversation = {};
        this.from = '';
        this.content = {};
        this.messageId = 0;
        this.direction = 0;
        this.status = 0;
        this.messageUid = 0;
        this.timestamp = 0;
        this.to = '';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Message, null, [{
        key: 'toMessage',
        value: function toMessage(state, sendMessage) {
            var message = new Message();
            var target = sendMessage.target;
            if (!target) {
                target = state.selectTarget;
            }
            console.log("to message target " + target);
            var stateConversationInfo = state.conversations.find(function (conversation) {
                return conversation.conversationInfo.target === target;
            });
            console.log("conversationtype " + stateConversationInfo.conversationInfo.conversationType + " target " + stateConversationInfo.conversationInfo.target);
            message.conversation = new __WEBPACK_IMPORTED_MODULE_2__model_conversation__["a" /* default */](stateConversationInfo.conversationInfo.conversationType, stateConversationInfo.conversationInfo.target, stateConversationInfo.conversationInfo.line);
            message.content = sendMessage.messageContent;
            message.from = state.userId;
            message.status = __WEBPACK_IMPORTED_MODULE_3__messageStatus__["a" /* default */].Sending;
            message.timestamp = new Date().getTime();
            message.direction = 0;
            message.messageId = new Date().getTime();
            return message;
        }
    }, {
        key: 'conert2Message',
        value: function conert2Message(sendMessage) {
            var message = new Message();
            var target = sendMessage.target;
            if (!target) {
                target = __WEBPACK_IMPORTED_MODULE_4__vuex__["a" /* default */].state.selectTarget;
            }
            console.log("to message target " + target);
            var stateConversationInfo = __WEBPACK_IMPORTED_MODULE_4__vuex__["a" /* default */].state.conversations.find(function (conversation) {
                return conversation.conversationInfo.target === target;
            });
            console.log("conversationtype " + stateConversationInfo.conversationInfo.conversationType + " target " + stateConversationInfo.conversationInfo.target);
            message.conversation = new __WEBPACK_IMPORTED_MODULE_2__model_conversation__["a" /* default */](stateConversationInfo.conversationInfo.conversationType, stateConversationInfo.conversationInfo.target, stateConversationInfo.conversationInfo.line);
            message.content = sendMessage.messageContent;
            message.from = __WEBPACK_IMPORTED_MODULE_5__utils_localstore__["a" /* default */].getUserId();
            message.status = __WEBPACK_IMPORTED_MODULE_3__messageStatus__["a" /* default */].Sending;
            message.timestamp = new Date().getTime();
            message.direction = 0;
            message.messageId = new Date().getTime();
            return message;
        }
    }]);

    return Message;
}();

/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_fontSize__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_js_fontSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_js_fontSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_wcPop_wcPop__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_js_wcPop_wcPop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_js_wcPop_wcPop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_wcPop_skin_wcPop_css__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_js_wcPop_skin_wcPop_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_js_wcPop_skin_wcPop_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_photo_preview__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_photo_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_photo_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_photo_preview_dist_skin_css__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_photo_preview_dist_skin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_photo_preview_dist_skin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__vuex__ = __webpack_require__(39);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_6_mint_ui__["Loadmore"].name, __WEBPACK_IMPORTED_MODULE_6_mint_ui__["Loadmore"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_mint_ui___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_photo_preview___default.a, {
  loop: false, fullscreenEl: false,
  arrowEl: false });



new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_11__vuex__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6802a516_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(148);
function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var normalizeComponent = __webpack_require__(54)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6802a516_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2764962c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(140);
function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var normalizeComponent = __webpack_require__(54)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2764962c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showHeader),expression:"$route.meta.showHeader"}],staticClass:"wcim__topBar"},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inner flexbox flex-alignc"},[_c('h4',{staticClass:"barTxt flex1"},[_c('div',{staticClass:"barCell flexbox flex__direction-column"},[_c('em',{staticClass:"clamp1"},[_vm._v("飞享移动版")])])]),_vm._v(" "),_c('a',{staticClass:"linkico wcim__ripple-fff",attrs:{"href":"javascript:;"}},[_c('i',{staticClass:"iconfont icon-search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4c0642_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(143);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(54)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d4c0642_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.meta.showTabBar),expression:"$route.meta.showTabBar"}],staticClass:"wcim__tabBar"},[_c('div',{staticClass:"bottomfixed wcim__borT"},[_c('ul',{staticClass:"flexbox flex-alignc"},[_c('router-link',{staticClass:"flex1",attrs:{"active-class":"on","tag":"li","to":"/","exact":""}},[_c('span',{staticClass:"ico"},[_c('i',{staticClass:"iconfont icon-tabbar_xiaoxi"}),_vm._v(" "),(_vm.unreadTotalCount > 0)?_c('em',{staticClass:"wcim__badge"},[_vm._v(_vm._s(_vm.unreadTotalCount))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"txt"},[_vm._v("消息")])]),_vm._v(" "),_c('router-link',{staticClass:"flex1",attrs:{"active-class":"on","tag":"li","to":"/contact"}},[_c('span',{staticClass:"ico"},[_c('i',{staticClass:"iconfont icon-tabbar_tongxunlu"})]),_vm._v(" "),_c('span',{staticClass:"txt"},[_vm._v("通讯录")])]),_vm._v(" "),_c('router-link',{staticClass:"flex1",attrs:{"active-class":"on","tag":"li","to":"/ucenter"}},[_c('span',{staticClass:"ico"},[_c('i',{staticClass:"iconfont icon-tabbar_wo"})]),_vm._v(" "),_c('span',{staticClass:"txt"},[_vm._v("我")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weChatIM__panel clearfix"},[_c('div',{staticClass:"we__chatIM-wrapper flexbox flex__direction-column"},[_c('header-bar',{class:{'topfixed': _vm.isTopFixed}}),_vm._v(" "),_c('div',{staticClass:"wcim__container flex1"},[_c('keep-alive',[_c('router-view')],1)],1),_vm._v(" "),_c('tab-bar')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 149 */
/***/ (function(module, exports) {

(function (doc, win) {
	var docEl = doc.documentElement,
	    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
	    recalc = function recalc() {
		var clientWidth = docEl.clientWidth;
		if (!clientWidth) return;
		if (clientWidth >= 750) {
			docEl.style.fontSize = "100px";
		} else {
			docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
		}
	};

	if (!doc.addEventListener) return;
	recalc();
	win.addEventListener(resizeEvt, recalc, false);
})(document, window);

/***/ }),
/* 150 */
/***/ (function(module, exports) {


!function (f) {
	var g = f.document,
	    d = g.documentElement,
	    c = 0,
	    a = { $: function $(h) {
			return g.getElementById(h);
		}, touch: function touch(j, i, h) {
			j.addEventListener(i || "click", function (k) {
				h.call(this, k);
			}, !1);
		}, jspath: function jspath() {
			for (var j = g.getElementsByTagName("script"), h = j.length; h > 0; h--) {
				if (j[h - 1].src && j[h - 1].src.match(/wcPop[\w\-\.]*\.js/) != null) {
					return j[h - 1].src.substring(0, j[h - 1].src.lastIndexOf("/") + 1);
				}
			}
		}, extend: function extend(k, j) {
			for (var h in j) {
				if (!(h in k)) {
					k[h] = j[h];
				}
			}return k;
		}, timer: {}, show: {}, end: {}, direction: function direction(i, h, k, j) {
			return Math.abs(i - h) >= Math.abs(k - j) ? i - h > 0 ? "left" : "right" : k - j > 0 ? "up" : "down";
		}, swipe: function swipe(i, h) {
			a.touch(i, "touchstart", function (o) {
				var m, l, k, j, n;m = Math.floor(o.touches[0].pageX);l = Math.floor(o.touches[0].pageY);a.touch(i, "touchmove", function (p) {
					p.preventDefault();k = p.changedTouches[0].pageX;j = p.changedTouches[0].pageY;
				});a.touch(i, "touchend", function (r) {
					if (k && Math.abs(m - k) > 50 || j && Math.abs(l - j) > 50) {
						n = a.direction(m, k, l, j);
					}for (var q = 0, p = h.swipe.length; q < p; q++) {
						if (h.swipe[q].direction == n) {
							typeof h.swipe[q].fn === "function" && h.swipe[q].fn(r);
						}
					}m = l = null;i.removeEventListener("touchmove", this, false);
				});
			});
		}, chkPosition: function chkPosition(l, i, h, m, k, o) {
			var j = l + h > k ? l - h : l;var n = i + m > o ? i - m : i;return [j, n];
		} },
	    e = function e(i) {
		var j = this,
		    h = { id: "wcPop", title: "", content: "", style: "", skin: "", icon: "", shade: true, shadeClose: true, opacity: "", xclose: false, anim: "scaleIn", position: "", follow: null, time: 0, zIndex: 9999, swipe: null, btns: null };j.opts = a.extend(i, h);j.init();
	};e.prototype = { init: function init() {
			var k = this,
			    h = k.opts,
			    j = null,
			    i = function () {
				if (!h.btns) {
					return;
				}var m = "";for (var l in h.btns) {
					m += '<span class="btn" data-index="' + l + '" style="' + (h.btns[l].style ? h.btns[l].style : "") + '">' + h.btns[l].text + "</span>";
				}return m;
			}();a.$(h.id) ? j = a.$(h.id) : (j = g.createElement("div"), j.id = h.id);h.skin && j.setAttribute("type", h.skin);j.setAttribute("index", c);j.setAttribute("class", "wcPop wcPop" + c);j.innerHTML = ['<div class="popui__modal-panel">', h.shade ? '<div class="popui__modal-mask" style="' + (h.opacity != null ? "opacity:" + h.opacity : "") + "; z-index:" + (k.maxIndex() + 1) + '"></div>' : "", '<div class="popui__panel-main" style="z-index:' + (k.maxIndex() + 2) + '">						<div class="popui__panel-section">							<div class="popui__panel-child ' + (h.anim ? "anim-" + h.anim : "") + " " + (h.skin ? "popui__" + h.skin : "") + " " + (h.position ? h.position : "") + '" style="' + h.style + '">', h.title ? '<div class="popui__panel-tit">' + h.title + "</div>" : "", h.content ? '<div class="popui__panel-cnt">' + (h.skin == "toast" && h.icon ? '<div class="popui__toast-icon"><img class="' + (h.icon == "loading" ? "anim-loading" : "") + '" src="' + a.jspath() + "skin/" + h.icon + '.png" /></div>' : "") + h.content + "</div>" : "", h.btns ? '<div class="popui__panel-btn">' + i + "</div>" : "", h.xclose ? '<span class="popui__xclose"></span>' : "", "</div>						</div>					</div>				</div>"].join("");g.body.appendChild(j);g.getElementsByTagName("body")[0].classList.add("popui__overflow");h.show && h.show.call(this);this.index = c++;k.callback();
		}, callback: function callback() {
			var r = this,
			    h = r.opts,
			    v = a.$(h.id);if (h.time) {
				a.timer[r.index] = setTimeout(function () {
					b.close(r.index);
				}, h.time * 1000);
			}if (h.btns) {
				for (var k = v.getElementsByClassName("popui__panel-btn")[0].children, s = k.length, q = 0; q < s; q++) {
					a.touch(k[q], "click", function (o) {
						var i = this.getAttribute("data-index"),
						    j = h.btns[i];typeof j.onTap === "function" && j.onTap(o);
					});
				}
			}if (h.shade && h.shadeClose) {
				var w = v.getElementsByClassName("popui__modal-mask")[0];a.touch(w, "click", function () {
					b.close(r.index);
				});
			}if (h.xclose) {
				var z = v.getElementsByClassName("popui__xclose")[0];a.touch(z, "click", function () {
					b.close(r.index);
				});
			}var p = v.getElementsByClassName("popui__panel-btn")[0];var q = v.getElementsByClassName("popui__modal-mask")[0];p && p.addEventListener("contextmenu", function (i) {
				i.preventDefault();
			}, !1);q && q.addEventListener("contextmenu", function (i) {
				i.preventDefault();
			}, !1);if (h.follow) {
				var u = v.getElementsByClassName("popui__panel-child")[0];var t, l, y, n;t = u.clientWidth;l = u.clientHeight;y = window.innerWidth;n = window.innerHeight;console.log("dom宽度：" + t);console.log("dom高度：" + l);console.log("屏幕宽度：" + y);console.log("屏幕高度：" + n);var A = a.chkPosition(h.follow[0], h.follow[1], t, l, y, n);console.log(A);u.style.left = A[0] + "px";u.style.top = A[1] + "px";
			}var m = v.getElementsByClassName("popui__panel-main")[0];h.swipe && a.swipe(m, h);h.end && (a.end[r.index] = h.end);
		}, maxIndex: function maxIndex() {
			for (var j = this.opts.zIndex, l = g.getElementsByTagName("*"), k = 0, h = l.length; k < h; k++) {
				j = Math.max(j, l[k].style.zIndex);
			}return j;
		} };var b = function () {
		fn = function fn(h) {
			var i = new e(h);return i.index;
		};fn.close = function (h) {
			var h = h || "";var i = g.getElementsByClassName("wcPop" + h)[0];if (i) {
				i.setAttribute("class", "wcPop-close");setTimeout(function () {
					g.body.removeChild(i);clearTimeout(a.timer[h]);delete a.timer[h];typeof a.end[h || 0] == "function" && a.end[h || 0].call(this);delete a.end[h || 0];
				}, 200);g.getElementsByTagName("body")[0].classList.remove("popui__overflow");
			}
		};fn.closeAll = function () {
			for (var k = g.getElementsByClassName(["wcPop"]), j = 0, h = k.length; j < h; j++) {
				fn.close(0 | k[0].getAttribute("index"));
			}
		};fn.load = function (k) {
			for (var h = g.createElement("link"), l = g.getElementsByTagName("link"), j = l.length; j > 0; j--) {
				if (l[j - 1].href == k) {
					return;
				}
			}h.type = "text/css";h.rel = "stylesheet";h.href = a.jspath() + k;g.getElementsByTagName("head")[0].appendChild(h);
		};fn.moreAPI = function (k, i, j) {
			var h = { title: k, content: i, time: j };fn(h);
		};return fn;
	}();f.wcPop = b;
}(window);

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_localstore__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_aes__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__message_websocketprotomessage__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__handler_connectackhandler__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__constant_config__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__vuex__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__future_promiseResolve__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__future_futureResult__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__handler_getfriendresultHandler__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__handler_getuserinfoHandler__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__handler_receiveMessageHandler__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__handler_getGroupInfoHandler__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handler_notifyMessageHandler__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__handler_getUploadtokenHandler__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__handler_getGroupMemberHandler__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__handler_getMinioUploadUrlHandler__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__handler_sendMessageHandler__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__handler_notifyRecallMessageHandler__ = __webpack_require__(281);


























var WebSocketClient = function () {
    function WebSocketClient() {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, WebSocketClient);

        this.handlerList = [];
        this.userDisconnect = false;
        this.isconnected = false;
        this.resolvePromiseMap = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();

        this.ws_protocol = __WEBPACK_IMPORTED_MODULE_11__constant_config__["i" /* WS_PROTOCOL */];
        this.ip = __WEBPACK_IMPORTED_MODULE_11__constant_config__["g" /* WS_IP */];
        this.port = __WEBPACK_IMPORTED_MODULE_11__constant_config__["h" /* WS_PORT */];
        this.heartbeatTimeout = __WEBPACK_IMPORTED_MODULE_11__constant_config__["b" /* HEART_BEAT_INTERVAL */];
        this.reconnectInterval = __WEBPACK_IMPORTED_MODULE_11__constant_config__["d" /* RECONNECT_INTERVAL */];
        this.binaryType = __WEBPACK_IMPORTED_MODULE_11__constant_config__["a" /* BINTRAY_TYPE */];
        this.url = __WEBPACK_IMPORTED_MODULE_11__constant_config__["i" /* WS_PROTOCOL */] + '://' + __WEBPACK_IMPORTED_MODULE_11__constant_config__["g" /* WS_IP */];
        this.initHandlerList();
        this.connect(true);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(WebSocketClient, [{
        key: 'connect',
        value: function connect(isReconncect) {
            this.ws = new WebSocket(this.url);
            console.log("current url " + this.url + " status " + this.ws.readyState);
            this.ws.binaryType = this.binaryType;
            var websocketObj = this;
            this.ws.onopen = function (event) {
                console.log("ws open");
                websocketObj.isconnected = true;
                websocketObj.lastInteractionTime(new Date().getTime());
                websocketObj.pingIntervalId = setInterval(function () {
                    websocketObj.ping();
                }, websocketObj.heartbeatTimeout);
                websocketObj.userDisconnect = false;

                websocketObj.sendConnectMessage();
            };
            this.ws.onmessage = function (event) {
                console.log("ws onmessage[" + event.data + "]");
                websocketObj.processMessage(event.data);
                websocketObj.lastInteractionTime(new Date().getTime());
            };
            this.ws.onclose = function (event) {
                websocketObj.isconnected = false;
                console.log("ws onclose");
                websocketObj.ws.close();
                clearInterval(websocketObj.pingIntervalId);
                if (!websocketObj.userDisconnect) {
                    console.log("reconnect websocket");
                    websocketObj.reconnect(event);
                }
            };
            this.ws.onerror = function (event) {
                console.log("connect error");
            };
        }
    }, {
        key: 'reconnect',
        value: function reconnect(event) {
            var websocketObj = this;
            setTimeout(function () {
                websocketObj.connect(true);
            }, this.reconnectInterval);
        }
    }, {
        key: 'initHandlerList',
        value: function initHandlerList() {
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_10__handler_connectackhandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_15__handler_getfriendresultHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_16__handler_getuserinfoHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_17__handler_receiveMessageHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_18__handler_getGroupInfoHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_19__handler_notifyMessageHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_20__handler_getUploadtokenHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_21__handler_getGroupMemberHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_22__handler_getMinioUploadUrlHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_23__handler_sendMessageHandler__["a" /* default */](this));
            this.handlerList.push(new __WEBPACK_IMPORTED_MODULE_24__handler_notifyRecallMessageHandler__["a" /* default */](this));
        }
    }, {
        key: 'lastInteractionTime',
        value: function lastInteractionTime(actionTime) {
            this.actionTime = actionTime;
        }
    }, {
        key: 'getLastActionTime',
        value: function getLastActionTime() {
            return this.actionTime;
        }
    }, {
        key: 'ping',
        value: function ping() {
            this.send('心跳内容');
        }
    }, {
        key: 'sendAction',
        value: function sendAction(type, data) {
            __WEBPACK_IMPORTED_MODULE_12__vuex__["a" /* default */].dispatch(type, data);
        }
    }, {
        key: 'send',
        value: function send(data) {
            console.log("send message " + data);
            if (this.isconnected) {
                this.ws.send(data);
            } else {
                console.log("curent websocket is close");
            }
        }
    }, {
        key: 'processMessage',
        value: function processMessage(data) {
            var protoObj = JSON.parse(data);
            for (var i = 0; i < this.handlerList.length; i++) {
                if (this.handlerList[i].match(protoObj)) {
                    this.handlerList[i].processMessage(protoObj);
                }
            }
        }
    }, {
        key: 'sendConnectMessage',
        value: function sendConnectMessage() {
            console.log("userToken " + __WEBPACK_IMPORTED_MODULE_6__utils_localstore__["a" /* default */].getToken());
            var allToken = Object(__WEBPACK_IMPORTED_MODULE_7__utils_aes__["a" /* decrypt */])(__WEBPACK_IMPORTED_MODULE_6__utils_localstore__["a" /* default */].getToken());
            console.log("decryptToken " + allToken);
            var pwd = allToken.substring(0, allToken.indexOf('|'));
            allToken = allToken.substring(allToken.indexOf('|') + 1);
            var secret = allToken.substring(0, allToken.indexOf('|'));
            console.log('[pwd]->' + pwd + ' [secret]->' + secret);
            var pwdAesBase64 = Object(__WEBPACK_IMPORTED_MODULE_7__utils_aes__["b" /* encrypt */])(pwd, secret);
            console.log('encrypt pwd: ' + pwdAesBase64);

            var websocketprotomessage = new __WEBPACK_IMPORTED_MODULE_9__message_websocketprotomessage__["a" /* WebSocketProtoMessage */]();
            console.log("deviceid " + __WEBPACK_IMPORTED_MODULE_6__utils_localstore__["a" /* default */].getDeviceId());
            websocketprotomessage.setSignal(__WEBPACK_IMPORTED_MODULE_8__constant_system__["a" /* CONNECT */]);
            var connectMessage = {
                userName: __WEBPACK_IMPORTED_MODULE_6__utils_localstore__["a" /* default */].getUserId(),
                password: pwdAesBase64,
                clientIdentifier: __WEBPACK_IMPORTED_MODULE_6__utils_localstore__["a" /* default */].getDeviceId()
            };
            websocketprotomessage.content = connectMessage;
            console.log(websocketprotomessage.toJson());
            this.send(websocketprotomessage.toJson());
        }
    }, {
        key: 'sendDisConnectMessage',
        value: function sendDisConnectMessage() {
            var websocketprotomessage = new __WEBPACK_IMPORTED_MODULE_9__message_websocketprotomessage__["a" /* WebSocketProtoMessage */]();
            websocketprotomessage.setSignal(__WEBPACK_IMPORTED_MODULE_8__constant_system__["d" /* DISCONNECT */]);
            var disconnectMessage = {
                clearSession: 1
            };
            websocketprotomessage.content = disconnectMessage;
            console.log(websocketprotomessage.toJson());
            this.send(websocketprotomessage.toJson());
            this.userDisconnect = true;
        }
    }, {
        key: 'getFriend',
        value: function getFriend() {
            this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["f" /* FP */], { version: 0 });
        }
    }, {
        key: 'getUserInfos',
        value: function getUserInfos(userIds) {
            this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["y" /* UPUI */], userIds);
        }
    }, {
        key: 'getUserInfo',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(userId) {
                var promise;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["y" /* UPUI */], [userId]);

                            case 2:
                                promise = _context.sent;
                                return _context.abrupt('return', promise);

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getUserInfo(_x) {
                return _ref.apply(this, arguments);
            }

            return getUserInfo;
        }()
    }, {
        key: 'getGroupMember',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(groupId, refresh) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["j" /* GPGM */], {
                                    groupId: groupId,
                                    version: 0
                                });

                            case 2:
                                return _context2.abrupt('return', _context2.sent);

                            case 3:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getGroupMember(_x2, _x3) {
                return _ref2.apply(this, arguments);
            }

            return getGroupMember;
        }()
    }, {
        key: 'pullMessage',
        value: function pullMessage(messageId) {
            var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var pullType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var sendMessageCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

            this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["q" /* MP */], {
                messageId: messageId,
                type: type,
                pullType: pullType,
                sendMessageCount: sendMessageCount
            });
        }
    }, {
        key: 'getGroupInfo',
        value: function getGroupInfo(groupId, refresh) {
            var groupIds = [];
            groupIds.push(groupId);
            this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["i" /* GPGI */], groupIds);
        }
    }, {
        key: 'getUploadToken',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(mediaType) {
                var content;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                content = {
                                    mediaType: mediaType
                                };
                                _context3.next = 3;
                                return this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["k" /* GQNUT */], content);

                            case 3:
                                return _context3.abrupt('return', _context3.sent);

                            case 4:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getUploadToken(_x7) {
                return _ref3.apply(this, arguments);
            }

            return getUploadToken;
        }()
    }, {
        key: 'getMinioUploadUrl',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(mediaType, key) {
                var content;
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                content = {
                                    mediaType: mediaType,
                                    key: key
                                };
                                _context4.next = 3;
                                return this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["h" /* GMURL */], content);

                            case 3:
                                return _context4.abrupt('return', _context4.sent);

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function getMinioUploadUrl(_x8, _x9) {
                return _ref4.apply(this, arguments);
            }

            return getMinioUploadUrl;
        }()
    }, {
        key: 'sendPublishMessage',
        value: function sendPublishMessage(subsignal, content) {
            var protoMessageId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

            var websocketprotomessage = new __WEBPACK_IMPORTED_MODULE_9__message_websocketprotomessage__["a" /* WebSocketProtoMessage */]();
            websocketprotomessage.setSignal(__WEBPACK_IMPORTED_MODULE_8__constant_system__["s" /* PUBLISH */]);
            websocketprotomessage.setSubSignal(subsignal);
            websocketprotomessage.setContent(content);
            var messageId = __WEBPACK_IMPORTED_MODULE_6__utils_localstore__["a" /* default */].getMessageId();
            if (messageId > 65535) {
                messageId = 0;
            }
            websocketprotomessage.setMessageId(++messageId);
            __WEBPACK_IMPORTED_MODULE_6__utils_localstore__["a" /* default */].saveMessageId(messageId);
            this.send(websocketprotomessage.toJson());

            var vueWebSocket = this;
            var pubAckPromise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                var timeoutId = setTimeout(function () {
                    if (subsignal == __WEBPACK_IMPORTED_MODULE_8__constant_system__["r" /* MS */]) {
                        var failProtoMessage = new __WEBPACK_IMPORTED_MODULE_9__message_websocketprotomessage__["a" /* WebSocketProtoMessage */]();
                        failProtoMessage.setSignal(__WEBPACK_IMPORTED_MODULE_8__constant_system__["t" /* PUB_ACK */]);
                        failProtoMessage.setSubSignal(subsignal);
                        failProtoMessage.setMessageId(messageId);
                        failProtoMessage.setContent('');
                        vueWebSocket.processMessage(failProtoMessage.toJson());
                    } else {
                        resolve(new __WEBPACK_IMPORTED_MODULE_14__future_futureResult__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__constant_system__["e" /* ERROR_CODE */], ""));
                    }
                }, 10000);
                var resolvePromise = new __WEBPACK_IMPORTED_MODULE_13__future_promiseResolve__["a" /* default */](resolve, timeoutId);
                resolvePromise.protoMessageId = protoMessageId;
                vueWebSocket.resolvePromiseMap.set(messageId, resolvePromise);
            });
            return pubAckPromise;
        }
    }, {
        key: 'sendMessage',
        value: function sendMessage(protoMessage) {
            this.sendPublishMessage(__WEBPACK_IMPORTED_MODULE_8__constant_system__["r" /* MS */], protoMessage, protoMessage.messageId);
        }
    }]);

    return WebSocketClient;
}();

/* harmony default export */ __webpack_exports__["a"] = (WebSocketClient);

/***/ }),
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decrypt;
/* harmony export (immutable) */ __webpack_exports__["b"] = encrypt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);



var iv = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Base64.parse('ABEiM0RVZnd4eXp7fH1+fw==');

function decrypt(text) {
    var decrypted = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.decrypt(text, iv, {
        iv: iv,
        mode: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.mode.CBC,
        padding: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.pad.Pkcs7
    });

    var resultWordArr = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Hex.parse(decrypted.toString().slice(8));
    var result = resultWordArr.toString(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8);

    return result;
}

function encrypt(encryptCode, key) {
    console.log('code ' + encryptCode + ' key ' + key);
    var keyArry = new Array(16);
    for (var i = 0; i < 16; i++) {
        keyArry[i] = key.charCodeAt(i) & 0xFF;
    }
    var keyCode = String.fromCharCode.apply(String, keyArry);
    var secretCode = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Utf8.parse(keyCode);
    console.log('keycode ' + keyCode);

    var timeEncryptCode = convertTimeEncryptCode(encryptCode);
    console.log('timeEncryptCode ' + timeEncryptCode);

    var encrypted = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.AES.encrypt(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Base64.parse(timeEncryptCode), secretCode, {
        iv: secretCode,
        mode: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.mode.CBC,
        padding: __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.pad.Pkcs7
    });
    return encrypted.ciphertext.toString(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Base64);
}

function convertTimeEncryptCode(encryptCode) {
    var encryptArr = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Base64.parse(encryptCode);

    encryptArr = wordToByteArray(encryptArr.words);

    var result = [];
    var curhour = (new Date().getMilliseconds() / 1000 - 1514736000) / 3600;
    for (var i = 0; i < encryptArr.length + 4; i++) {
        if (i < 4) {
            if (i == 0) {
                result.push(curhour & 0xFF);
            } else if (i == 1) {
                result.push((curhour & 0xFF00) >> 8);
            } else if (i == 2) {
                result.push((curhour & 0xFF0000) >> 16);
            } else if (i == 3) {
                result.push((curhour & 0xFF) >> 24);
            }
        } else {
            result.push(encryptArr[i - 4]);
        }
    }
    console.log('convertTimeEncryptCode result ' + result);

    var base64wordarr = btoa(String.fromCharCode.apply(String, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(new Uint8Array(result))));
    console.log("hash word " + base64wordarr);

    return base64wordarr;
}

function bin2String(array) {
    var result = "";
    for (var i = 0; i < array.length; i++) {
        result += String.fromCharCode(parseInt(array[i], 2));
    }
    return result;
}

function string2Bin(str) {
    var result = [];
    for (var i = 0; i < str.length; i++) {
        result.push(str.charCodeAt(i).toString(2));
    }
    return result;
}

function wordToByteArray(wordArray) {
    var byteArray = [],
        word,
        i,
        j;
    for (i = 0; i < wordArray.length; ++i) {
        word = wordArray[i];
        for (j = 3; j >= 0; --j) {
            byteArray.push(word >> 8 * j & 0xFF);
        }
    }
    return byteArray;
}

function byteArrayToString(byteArray) {
    var str = "",
        i;
    for (i = 0; i < byteArray.length; ++i) {
        str += escape(String.fromCharCode(byteArray[i]));
    }
    return str;
}

/***/ }),
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebSocketProtoMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var WebSocketProtoMessage = function () {
    function WebSocketProtoMessage() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WebSocketProtoMessage);

        console.log('constuctor WebSocketProtoMessage');
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WebSocketProtoMessage, [{
        key: 'setMessageId',
        value: function setMessageId(messageId) {
            this.messageId = messageId;
        }
    }, {
        key: 'setSignal',
        value: function setSignal(signal) {
            this.signal = signal;
        }
    }, {
        key: 'setSubSignal',
        value: function setSubSignal(subSignal) {
            this.subSignal = subSignal;
        }
    }, {
        key: 'setContent',
        value: function setContent(content) {
            this.content = content;
        }
    }, {
        key: 'toJson',
        value: function toJson() {
            var message = {
                signal: this.signal,
                subSignal: this.subSignal == null ? 'NONE' : this.subSignal,
                messageId: this.messageId == null ? 0 : this.messageId,
                content: this.content
            };

            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(message);
        }
    }]);

    return WebSocketProtoMessage;
}();

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_localstore__ = __webpack_require__(14);









var ConnectAckHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ConnectAckHandler, _AbstractMessageHandl);

    function ConnectAckHandler(vueWebsocket) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ConnectAckHandler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ConnectAckHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ConnectAckHandler)).call(this, vueWebsocket));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ConnectAckHandler, [{
        key: "match",
        value: function match(protoObj) {
            return protoObj.signal == __WEBPACK_IMPORTED_MODULE_5__constant_system__["b" /* CONNECT_ACK */];
        }
    }, {
        key: "processMessage",
        value: function processMessage(data) {
            console.log("ConnectAckHandler process message");
            var connectAcceptedMessage = JSON.parse(data.content);
            console.log("connectAcceptedMessage friendHead " + connectAcceptedMessage.friendHead + " messageHead " + connectAcceptedMessage.messageHead);

            this.vueWebsocket.getFriend();
            var lastMessageSeq = __WEBPACK_IMPORTED_MODULE_7__utils_localstore__["a" /* default */].getLastMessageSeq();
            if (!lastMessageSeq || lastMessageSeq == 0) {
                lastMessageSeq = '0';
                this.vueWebsocket.sendAction('changetFirstLogin', true);
            } else {
                this.vueWebsocket.sendAction('changetFirstLogin', false);
            }

            this.vueWebsocket.pullMessage(lastMessageSeq, 0, 0, __WEBPACK_IMPORTED_MODULE_7__utils_localstore__["a" /* default */].getSendMessageCount());
            __WEBPACK_IMPORTED_MODULE_7__utils_localstore__["a" /* default */].setLastMessageSeq(connectAcceptedMessage.messageHead);
        }
    }]);

    return ConnectAckHandler;
}(__WEBPACK_IMPORTED_MODULE_6__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ConnectAckHandler);

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var MessageHandler = function () {
    function MessageHandler() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MessageHandler);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MessageHandler, [{
        key: "match",
        value: function match(signal) {
            return false;
        }
    }, {
        key: "processMessage",
        value: function processMessage(data) {}
    }]);

    return MessageHandler;
}();

/* harmony default export */ __webpack_exports__["a"] = (MessageHandler);

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Logger = function () {
  function Logger() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Logger);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Logger, null, [{
    key: "log",
    value: function log(text) {
      var time = new Date();
      console.log("[" + time.toLocaleTimeString() + "] " + text);
    }
  }]);

  return Logger;
}();

/* harmony default export */ __webpack_exports__["a"] = (Logger);

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var PromiseResolve = function PromiseResolve(resolve, timeoutId) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PromiseResolve);

    this.resolve = resolve;
    this.timeoutId = timeoutId;
};

/* harmony default export */ __webpack_exports__["a"] = (PromiseResolve);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_localstore__ = __webpack_require__(14);









var GetFriendResultHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GetFriendResultHandler, _AbstractMessageHandl);

    function GetFriendResultHandler() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GetFriendResultHandler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GetFriendResultHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GetFriendResultHandler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GetFriendResultHandler, [{
        key: "match",
        value: function match(proto) {
            return proto.signal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["t" /* PUB_ACK */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["f" /* FP */];
        }
    }, {
        key: "notifyContent",
        value: function notifyContent(content) {
            var friendList = JSON.parse(content);
            var userIds = [];
            for (var i in friendList) {
                userIds[i] = friendList[i].friendUid;
            }
            this.vueWebsocket.sendAction("updateFriendIds", userIds);

            userIds.push(__WEBPACK_IMPORTED_MODULE_7__utils_localstore__["a" /* default */].getUserId());
            this.vueWebsocket.getUserInfos(userIds);
        }
    }]);

    return GetFriendResultHandler;
}(__WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GetFriendResultHandler);

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__model_userInfo__ = __webpack_require__(248);









var GetUserInfoHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GetUserInfoHandler, _AbstractMessageHandl);

    function GetUserInfoHandler() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GetUserInfoHandler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GetUserInfoHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GetUserInfoHandler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GetUserInfoHandler, [{
        key: "match",
        value: function match(proto) {
            return proto.signal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["t" /* PUB_ACK */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["y" /* UPUI */];
        }
    }, {
        key: "notifyContent",
        value: function notifyContent(content) {
            var userInfoList = JSON.parse(content);
            var userInfos = [];
            for (var i in userInfoList) {
                userInfos.push(__WEBPACK_IMPORTED_MODULE_7__model_userInfo__["a" /* default */].convert2UserInfo(userInfoList[i]));
            }
            this.vueWebsocket.sendAction("updateUserInfos", userInfos);
            return userInfos;
        }
    }]);

    return GetUserInfoHandler;
}(__WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GetUserInfoHandler);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pinyin__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pinyin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pinyin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant_system__ = __webpack_require__(10);





var UserInfo = function () {
    function UserInfo() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserInfo);

        this.uid = '';
        this.name = '';
        this.displayName = '';
        this.gender = 0;
        this.portrait = '';
        this.mobile = '';
        this.email = '';
        this.address = '';
        this.social = '';
        this.extra = '';
        this.type = 0;
        this.updateDt = 1550652404513;
        this.firstLetter = '';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserInfo, null, [{
        key: "convert2UserInfo",
        value: function convert2UserInfo(jsonObj) {
            var userInfo = new UserInfo();
            userInfo.uid = jsonObj.uid;
            userInfo.name = jsonObj.name;
            userInfo.mobile = jsonObj.mobile;
            var showDisplayName = jsonObj.displayName === '' ? jsonObj.mobile : jsonObj.displayName;
            userInfo.displayName = showDisplayName;
            userInfo.gender = jsonObj.gender;
            var showPortrait = __WEBPACK_IMPORTED_MODULE_3__constant_system__["c" /* DEFACULT_VUE_IMG */];
            if (jsonObj.portrait) {
                showPortrait = jsonObj.portrait;
            }
            userInfo.portrait = showPortrait;
            userInfo.email = jsonObj.email;
            userInfo.address = jsonObj.address;
            userInfo.social = jsonObj.social;
            userInfo.extra = jsonObj.extra;
            userInfo.type = jsonObj.type;
            userInfo.updateDt = jsonObj.updateDt;
            userInfo.firstLetter = this.getFristLetter(userInfo.displayName, userInfo.mobile);
            return userInfo;
        }
    }, {
        key: "getFristLetter",
        value: function getFristLetter(displayName, mobile) {
            var displayNameForLetter = displayName === '' ? mobile : displayName;
            var pinyinInitial = __WEBPACK_IMPORTED_MODULE_2_pinyin___default()(displayNameForLetter, {
                style: __WEBPACK_IMPORTED_MODULE_2_pinyin___default.a.STYLE_FIRST_LETTER
            });
            var initial = pinyinInitial[0][0];

            if (initial.length > 1) {
                var initial = initial.substr(0, 1);
                var reg = /^[A-Za-z]/;
                if (reg.test(initial)) {
                    initial = initial.toUpperCase();
                } else {
                    initial = "#";
                }
            } else {
                initial = initial.toUpperCase();
            }
            return initial;
        }
    }]);

    return UserInfo;
}();

/* harmony default export */ __webpack_exports__["a"] = (UserInfo);

/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__message_protomessage__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_localstore__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__message_messageConfig__ = __webpack_require__(83);












var ReceiveMessageHandler = function (_AbstractMessageHandl) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ReceiveMessageHandler, _AbstractMessageHandl);

  function ReceiveMessageHandler() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ReceiveMessageHandler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ReceiveMessageHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ReceiveMessageHandler)).call.apply(_ref, [this].concat(args))), _this), _this.conversations = [], _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ReceiveMessageHandler, [{
    key: "match",
    value: function match(proto) {
      return proto.signal == __WEBPACK_IMPORTED_MODULE_7__constant_system__["t" /* PUB_ACK */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_7__constant_system__["q" /* MP */];
    }
  }, {
    key: "notifyContent",
    value: function notifyContent(content) {
      __WEBPACK_IMPORTED_MODULE_9__utils_localstore__["a" /* default */].resetSendMessageCount();
      var content = JSON.parse(content);
      console.log("current " + content.current + " head " + content.head + " messageCount " + content.messageCount);
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(content.messageResponseList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var protoMessage = _step.value;

          var protoMessage = __WEBPACK_IMPORTED_MODULE_8__message_protomessage__["a" /* default */].toProtoMessage(protoMessage);
          if (__WEBPACK_IMPORTED_MODULE_10__message_messageConfig__["a" /* default */].isDisplayableMessage(protoMessage)) {
            this.addProtoMessage(protoMessage);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.vueWebsocket.sendAction('changetFirstLogin', false);
    }
  }, {
    key: "addProtoMessage",
    value: function addProtoMessage(protoMessage) {
      this.vueWebsocket.sendAction('addProtoMessage', protoMessage);
    }
  }]);

  return ReceiveMessageHandler;
}(__WEBPACK_IMPORTED_MODULE_6__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ReceiveMessageHandler);

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var PersistFlag = function PersistFlag() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PersistFlag);
};

PersistFlag.No_Persist = 0;
PersistFlag.Persist = 1;
PersistFlag.Persist_And_Count = 3;
PersistFlag.Transparent = 4;
/* harmony default export */ __webpack_exports__["a"] = (PersistFlag);

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messageContent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__messageContentType__ = __webpack_require__(7);








var UnknownMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UnknownMessageContent, _MessageContent);

    function UnknownMessageContent(originalPayload) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UnknownMessageContent);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UnknownMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UnknownMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_6__messageContentType__["a" /* default */].Unknown));

        _this.originalPayload = originalPayload;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UnknownMessageContent, [{
        key: "encode",
        value: function encode() {
            return this.originalPayload;
        }
    }, {
        key: "decode",
        value: function decode(paylaod) {
            this.originalPayload = paylaod;
        }
    }, {
        key: "digest",
        value: function digest() {
            return '未知类型消息';
        }
    }]);

    return UnknownMessageContent;
}(__WEBPACK_IMPORTED_MODULE_5__messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (UnknownMessageContent);

/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__messageContent__ = __webpack_require__(20);







var UnsupportMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UnsupportMessageContent, _MessageContent);

    function UnsupportMessageContent() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UnsupportMessageContent);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UnsupportMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UnsupportMessageContent)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UnsupportMessageContent, [{
        key: "digest",
        value: function digest() {
            return '尚不支持该类型消息, 请手机查看 : ' + this.type;
        }
    }]);

    return UnsupportMessageContent;
}(__WEBPACK_IMPORTED_MODULE_5__messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (UnsupportMessageContent);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__ = __webpack_require__(15);










var CallAnswerMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CallAnswerMessageContent, _MessageContent);

    function CallAnswerMessageContent() {
        var mentionedType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var mentionedTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CallAnswerMessageContent);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CallAnswerMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallAnswerMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_ACCEPT, mentionedType, mentionedTargets));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CallAnswerMessageContent, [{
        key: 'digest',
        value: function digest() {
            return '';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallAnswerMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallAnswerMessageContent.prototype), 'encode', this).call(this);
            payload.content = this.callId;

            var obj;
            if (this.audioOnly) {
                obj = '1';
            } else {
                obj = '0';
            }
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].utf8_to_b64(obj);
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallAnswerMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallAnswerMessageContent.prototype), 'decode', this).call(this, payload);
            this.callId = payload.content;
            var str = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);

            this.audioOnly = str === '1';
        }
    }]);

    return CallAnswerMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CallAnswerMessageContent);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__ = __webpack_require__(15);











var CallAnswerTMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CallAnswerTMessageContent, _MessageContent);

    function CallAnswerTMessageContent() {
        var mentionedType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var mentionedTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CallAnswerTMessageContent);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CallAnswerTMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallAnswerTMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_ACCEPT_T, mentionedType, mentionedTargets));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CallAnswerTMessageContent, [{
        key: 'digest',
        value: function digest() {
            return '';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallAnswerTMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallAnswerTMessageContent.prototype), 'encode', this).call(this);
            payload.content = this.callId;

            var obj;
            if (this.audioOnly) {
                obj = '1';
            } else {
                obj = '0';
            }
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].utf8_to_b64(obj);
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallAnswerTMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallAnswerTMessageContent.prototype), 'decode', this).call(this, payload);
            this.callId = payload.content;
            var str = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);

            this.audioOnly = str === '1';
        }
    }]);

    return CallAnswerTMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CallAnswerTMessageContent);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__ = __webpack_require__(15);










var CallSignalMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CallSignalMessageContent, _MessageContent);

    function CallSignalMessageContent() {
        var mentionedType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var mentionedTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CallSignalMessageContent);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CallSignalMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallSignalMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_SIGNAL, mentionedType, mentionedTargets));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CallSignalMessageContent, [{
        key: 'digest',
        value: function digest() {
            return '';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallSignalMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallSignalMessageContent.prototype), 'encode', this).call(this);
            payload.content = this.callId;
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].utf8_to_b64(this.payload);
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallSignalMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallSignalMessageContent.prototype), 'decode', this).call(this, payload);
            this.callId = payload.content;
            this.payload = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
        }
    }]);

    return CallSignalMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CallSignalMessageContent);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__ = __webpack_require__(7);










var CallByeMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CallByeMessageContent, _MessageContent);

    function CallByeMessageContent() {
        var mentionedType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var mentionedTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CallByeMessageContent);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CallByeMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallByeMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_END, mentionedType, mentionedTargets));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CallByeMessageContent, [{
        key: 'digest',
        value: function digest() {
            return '';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallByeMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallByeMessageContent.prototype), 'encode', this).call(this);
            payload.content = this.callId;
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallByeMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallByeMessageContent.prototype), 'decode', this).call(this, payload);
            this.callId = payload.content;
        }
    }]);

    return CallByeMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CallByeMessageContent);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__ = __webpack_require__(15);










var CallModifyMessageContent = function (_MessageContent) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CallModifyMessageContent, _MessageContent);

    function CallModifyMessageContent() {
        var mentionedType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var mentionedTargets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CallModifyMessageContent);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CallModifyMessageContent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallModifyMessageContent)).call(this, __WEBPACK_IMPORTED_MODULE_7__websocket_message_messageContentType__["a" /* default */].VOIP_CONTENT_TYPE_MODIFY, mentionedType, mentionedTargets));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CallModifyMessageContent, [{
        key: 'digest',
        value: function digest() {
            return '';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallModifyMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallModifyMessageContent.prototype), 'encode', this).call(this);
            payload.content = this.callId;

            var obj;
            if (this.audioOnly) {
                obj = '1';
            } else {
                obj = '0';
            }
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].utf8_to_b64(obj);
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(CallModifyMessageContent.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CallModifyMessageContent.prototype), 'decode', this).call(this, payload);
            this.callId = payload.content;
            var str = __WEBPACK_IMPORTED_MODULE_8__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);

            this.audioOnly = str === '1';
        }
    }]);

    return CallModifyMessageContent;
}(__WEBPACK_IMPORTED_MODULE_6__websocket_message_messageContent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CallModifyMessageContent);

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__groupNotification__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websocketcli__ = __webpack_require__(25);













var CreateGroupNotification = function (_GroupNotificationCon) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(CreateGroupNotification, _GroupNotificationCon);

    function CreateGroupNotification(creator, groupName) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CreateGroupNotification);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CreateGroupNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CreateGroupNotification)).call(this, __WEBPACK_IMPORTED_MODULE_7__messageContentType__["a" /* default */].CreateGroup_Notification));

        _this.creator = '';
        _this.groupName = '';

        _this.creator = creator;
        _this.groupName = groupName;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CreateGroupNotification, [{
        key: 'formatNotification',
        value: function formatNotification() {
            if (this.fromSelf) {
                return '您创建了群组 ' + this.groupName;
            } else {
                return __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(this.creator) + ' 创建了群组 ' + this.groupName;
            }
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(CreateGroupNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CreateGroupNotification.prototype), 'encode', this).call(this);
            var obj = {
                g: this.groupId,
                n: this.groupName,
                o: this.creator
            };
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].utf8_to_b64(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(CreateGroupNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CreateGroupNotification.prototype), 'decode', this).call(this, payload);
            var json = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
            var obj = JSON.parse(json);
            this.groupId = obj.g;
            this.creator = obj.o;
            this.groupName = obj.n;
        }
    }]);

    return CreateGroupNotification;
}(__WEBPACK_IMPORTED_MODULE_8__groupNotification__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CreateGroupNotification);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__groupNotification__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websocketcli__ = __webpack_require__(25);













var ChangeGroupNameNotification = function (_GroupNotificationCon) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ChangeGroupNameNotification, _GroupNotificationCon);

    function ChangeGroupNameNotification(operator, name) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ChangeGroupNameNotification);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChangeGroupNameNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ChangeGroupNameNotification)).call(this, __WEBPACK_IMPORTED_MODULE_7__messageContentType__["a" /* default */].ChangeGroupName_Notification));

        _this.operator = '';
        _this.name = '';

        _this.operator = operator;
        _this.name = name;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ChangeGroupNameNotification, [{
        key: "formatNotification",
        value: function formatNotification() {
            if (this.fromSelf) {
                return '您修改群名称为：' + this.name;
            } else {
                return __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(this.operator) + ' 修改群名称为:' + this.name;
            }
        }
    }, {
        key: "encode",
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(ChangeGroupNameNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ChangeGroupNameNotification.prototype), "encode", this).call(this);
            var obj = {
                g: this.groupId,
                n: this.name,
                o: this.operator
            };
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].utf8_to_b64(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            return payload;
        }
    }, {
        key: "decode",
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(ChangeGroupNameNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ChangeGroupNameNotification.prototype), "decode", this).call(this, payload);
            var json = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
            var obj = JSON.parse(json);
            this.groupId = obj.g;
            this.operator = obj.o;
            this.name = obj.n;
        }
    }]);

    return ChangeGroupNameNotification;
}(__WEBPACK_IMPORTED_MODULE_8__groupNotification__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ChangeGroupNameNotification);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__groupNotification__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websocketcli__ = __webpack_require__(25);













var AddGroupMemberNotification = function (_GroupNotificationCon) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(AddGroupMemberNotification, _GroupNotificationCon);

    function AddGroupMemberNotification(invitor, invitees) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AddGroupMemberNotification);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AddGroupMemberNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AddGroupMemberNotification)).call(this, __WEBPACK_IMPORTED_MODULE_7__messageContentType__["a" /* default */].AddGroupMember_Notification));

        _this.invitor = '';
        _this.invitees = [];

        _this.invitor = invitor;
        _this.invitees = invitees;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AddGroupMemberNotification, [{
        key: 'formatNotification',
        value: function formatNotification() {
            var notifyStr = void 0;
            if (this.invitees.length === 1 && this.invitees[0] === this.invitor) {
                if (this.fromSelf) {
                    return '您加入了群组';
                } else {
                    return __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(this.invitor) + ' 加入了群组';
                }
            }

            if (this.fromSelf) {
                notifyStr = '您邀请:';
            } else {
                notifyStr = __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(this.invitor) + '邀请:';
            }

            var membersStr = '';
            this.invitees.forEach(function (m) {
                membersStr += ' ' + __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(m);
            });

            return notifyStr + membersStr + '加入了群组';
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(AddGroupMemberNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AddGroupMemberNotification.prototype), 'encode', this).call(this);
            var obj = {
                g: this.groupId,
                o: this.invitor,
                ms: this.invitees
            };
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].utf8_to_b64(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(AddGroupMemberNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AddGroupMemberNotification.prototype), 'decode', this).call(this, payload);
            var json = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
            var obj = JSON.parse(json);
            this.groupId = obj.g;
            this.invitor = obj.o;
            this.invitees = obj.ms;
        }
    }]);

    return AddGroupMemberNotification;
}(__WEBPACK_IMPORTED_MODULE_8__groupNotification__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (AddGroupMemberNotification);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__groupNotification__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websocketcli__ = __webpack_require__(25);













var QuitGroupNotification = function (_GroupNotificationCon) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(QuitGroupNotification, _GroupNotificationCon);

    function QuitGroupNotification(operator) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, QuitGroupNotification);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (QuitGroupNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(QuitGroupNotification)).call(this, __WEBPACK_IMPORTED_MODULE_7__messageContentType__["a" /* default */].QuitGroup_Notification));

        _this.operator = '';

        _this.operator = operator;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(QuitGroupNotification, [{
        key: 'formatNotification',
        value: function formatNotification() {
            if (this.fromSelf) {
                return '您退出了群组';
            } else {
                return __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(this.operator) + '退出了群组';
            }
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(QuitGroupNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(QuitGroupNotification.prototype), 'encode', this).call(this);
            var obj = {
                g: this.groupId,
                o: this.operator
            };
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].utf8_to_b64(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(QuitGroupNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(QuitGroupNotification.prototype), 'decode', this).call(this, payload);
            var json = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
            var obj = JSON.parse(json);
            this.groupId = obj.g;
            this.operator = obj.o;
        }
    }]);

    return QuitGroupNotification;
}(__WEBPACK_IMPORTED_MODULE_8__groupNotification__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (QuitGroupNotification);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__groupNotification__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websocketcli__ = __webpack_require__(25);













var KickoffGroupMemberNotification = function (_GroupNotificationCon) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(KickoffGroupMemberNotification, _GroupNotificationCon);

    function KickoffGroupMemberNotification(operator, kickedMembers) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, KickoffGroupMemberNotification);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (KickoffGroupMemberNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(KickoffGroupMemberNotification)).call(this, __WEBPACK_IMPORTED_MODULE_7__messageContentType__["a" /* default */].KickOffGroupMember_Notification));

        _this.operator = '';
        _this.kickedMembers = [];

        _this.operator = operator;
        _this.kickedMembers = kickedMembers;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(KickoffGroupMemberNotification, [{
        key: "formatNotification",
        value: function formatNotification() {
            var notifyStr = void 0;
            if (this.fromSelf) {
                notifyStr = '您把 ';
            } else {
                notifyStr = __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(this.operator) + '把 ';
            }

            var kickedMembersStr = '';
            this.kickedMembers.forEach(function (m) {
                kickedMembersStr += ' ' + __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(m);
            });

            return notifyStr + kickedMembersStr + ' 移除了群组';
        }
    }, {
        key: "encode",
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(KickoffGroupMemberNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(KickoffGroupMemberNotification.prototype), "encode", this).call(this);
            var obj = {
                g: this.groupId,
                ms: this.kickedMembers,
                o: this.operateUser
            };
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].utf8_to_b64(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            return payload;
        }
    }, {
        key: "decode",
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(KickoffGroupMemberNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(KickoffGroupMemberNotification.prototype), "decode", this).call(this, payload);
            var json = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
            var obj = JSON.parse(json);
            this.groupId = obj.g;
            this.operator = obj.o;
            this.kickedMembers = obj.ms;
        }
    }]);

    return KickoffGroupMemberNotification;
}(__WEBPACK_IMPORTED_MODULE_8__groupNotification__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (KickoffGroupMemberNotification);

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__messageContentType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__groupNotification__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websocketcli__ = __webpack_require__(25);













var DismissGroupNotification = function (_GroupNotificationCon) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DismissGroupNotification, _GroupNotificationCon);

    function DismissGroupNotification(operator) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DismissGroupNotification);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DismissGroupNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DismissGroupNotification)).call(this, __WEBPACK_IMPORTED_MODULE_7__messageContentType__["a" /* default */].DismissGroup_Notification));

        _this.operator = '';

        _this.operator = operator;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DismissGroupNotification, [{
        key: 'formatNotification',
        value: function formatNotification() {
            if (this.fromSelf) {
                return '您解散了群组';
            } else {
                return __WEBPACK_IMPORTED_MODULE_10__websocketcli__["a" /* default */].getDisplayName(this.operator) + '解散了群组';
            }
        }
    }, {
        key: 'encode',
        value: function encode() {
            var payload = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(DismissGroupNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DismissGroupNotification.prototype), 'encode', this).call(this);
            var obj = {
                g: this.groupId,
                o: this.operator
            };
            payload.binaryContent = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].utf8_to_b64(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
            return payload;
        }
    }, {
        key: 'decode',
        value: function decode(payload) {
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_get___default()(DismissGroupNotification.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DismissGroupNotification.prototype), 'decode', this).call(this, payload);
            var json = __WEBPACK_IMPORTED_MODULE_9__utils_StringUtil__["a" /* default */].b64_to_utf8(payload.binaryContent);
            var obj = JSON.parse(json);
            this.groupId = obj.g;
            this.operator = obj.o;
        }
    }]);

    return DismissGroupNotification;
}(__WEBPACK_IMPORTED_MODULE_8__groupNotification__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DismissGroupNotification);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_groupInfo__ = __webpack_require__(273);










var GetGroupInfoHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(GetGroupInfoHandler, _AbstractMessageHandl);

    function GetGroupInfoHandler() {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GetGroupInfoHandler);

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GetGroupInfoHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(GetGroupInfoHandler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GetGroupInfoHandler, [{
        key: "match",
        value: function match(proto) {
            return proto.signal == __WEBPACK_IMPORTED_MODULE_7__constant_system__["t" /* PUB_ACK */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_7__constant_system__["i" /* GPGI */];
        }
    }, {
        key: "notifyContent",
        value: function notifyContent(content) {
            var groupInfoList = JSON.parse(content);
            var groups = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(groupInfoList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var groupInfo = _step.value;

                    groups.push(__WEBPACK_IMPORTED_MODULE_8__model_groupInfo__["a" /* default */].convert2GroupInfo(groupInfo));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.vueWebsocket.sendAction("updateGroupInfos", groups);
            return groups;
        }
    }]);

    return GetGroupInfoHandler;
}(__WEBPACK_IMPORTED_MODULE_6__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GetGroupInfoHandler);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__groupType__ = __webpack_require__(274);




var GroupInfo = function () {
   function GroupInfo() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GroupInfo);

      this.target = '';
      this.name = '';
      this.portrait = '';
      this.owner = '';
      this.type = __WEBPACK_IMPORTED_MODULE_2__groupType__["a" /* default */].Normal;
      this.memberCount = 0;
      this.extra = '';
      this.updateDt = 0;
   }

   __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(GroupInfo, null, [{
      key: 'convert2GroupInfo',
      value: function convert2GroupInfo(jsonObj) {
         var groupInfo = new GroupInfo();
         groupInfo.target = jsonObj.target;
         groupInfo.name = jsonObj.name;
         groupInfo.portrait = jsonObj.portrait;
         groupInfo.owner = jsonObj.owner;
         groupInfo.type = jsonObj.type;
         groupInfo.memberCount = jsonObj.memberCount;
         groupInfo.extra = jsonObj.extra;
         groupInfo.updateDt = jsonObj.updateDt;
         return groupInfo;
      }
   }]);

   return GroupInfo;
}();

/* harmony default export */ __webpack_exports__["a"] = (GroupInfo);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var GroupType = function GroupType() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GroupType);
};

GroupType.Normal = 0;
GroupType.Free = 1;
GroupType.Restricted = 2;
/* harmony default export */ __webpack_exports__["a"] = (GroupType);

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_localstore__ = __webpack_require__(14);









var NotifyMessageHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NotifyMessageHandler, _AbstractMessageHandl);

    function NotifyMessageHandler() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NotifyMessageHandler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotifyMessageHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(NotifyMessageHandler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NotifyMessageHandler, [{
        key: "match",
        value: function match(proto) {
            return proto.signal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["s" /* PUBLISH */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["p" /* MN */];
        }
    }, {
        key: "processMessage",
        value: function processMessage(proto) {
            console.log("notifymessage " + proto.content);
            var notify = JSON.parse(proto.content);
            console.log("notify messageHead " + notify.messageHead + " notify type " + notify.type);

            __WEBPACK_IMPORTED_MODULE_7__utils_localstore__["a" /* default */].resetSendMessageCount();
            __WEBPACK_IMPORTED_MODULE_7__utils_localstore__["a" /* default */].setLastMessageSeq(notify.messageHead);
            this.vueWebsocket.pullMessage(notify.messageHead, notify.type, 1);
        }
    }]);

    return NotifyMessageHandler;
}(__WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NotifyMessageHandler);

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_system__ = __webpack_require__(10);








var UploadTokenHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(UploadTokenHandler, _AbstractMessageHandl);

    function UploadTokenHandler() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, UploadTokenHandler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UploadTokenHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(UploadTokenHandler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(UploadTokenHandler, [{
        key: "match",
        value: function match(proto) {
            return proto.signal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["t" /* PUB_ACK */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["k" /* GQNUT */];
        }
    }, {
        key: "notifyContent",
        value: function notifyContent(content) {
            var uploadTokenResponse = JSON.parse(content);
            var domain = uploadTokenResponse.domain;
            var token = uploadTokenResponse.token;
            console.log("domain " + domain + " token " + token);
            return token;
        }
    }]);

    return UploadTokenHandler;
}(__WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (UploadTokenHandler);

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__model_groupMember__ = __webpack_require__(278);










var GetGroupMemberHandler = function (_AbstractMessageHandl) {
   __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(GetGroupMemberHandler, _AbstractMessageHandl);

   function GetGroupMemberHandler() {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GetGroupMemberHandler);

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GetGroupMemberHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(GetGroupMemberHandler)).apply(this, arguments));
   }

   __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GetGroupMemberHandler, [{
      key: "match",
      value: function match(proto) {
         return proto.signal == __WEBPACK_IMPORTED_MODULE_7__constant_system__["t" /* PUB_ACK */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_7__constant_system__["j" /* GPGM */];
      }
   }, {
      key: "notifyContent",
      value: function notifyContent(content) {
         var groupMemberList = JSON.parse(content);
         var groupMembers = [];
         var _iteratorNormalCompletion = true;
         var _didIteratorError = false;
         var _iteratorError = undefined;

         try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(groupMemberList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
               var groupMember = _step.value;

               groupMembers.push(__WEBPACK_IMPORTED_MODULE_8__model_groupMember__["a" /* default */].convert2GroupMember(groupMember));
            }
         } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
         } finally {
            try {
               if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
               }
            } finally {
               if (_didIteratorError) {
                  throw _iteratorError;
               }
            }
         }

         return groupMembers;
      }
   }]);

   return GetGroupMemberHandler;
}(__WEBPACK_IMPORTED_MODULE_6__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GetGroupMemberHandler);

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var GroupMember = function () {
    function GroupMember() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GroupMember);

        this.groupId = '';
        this.memberId = '';
        this.alias = '';
        this.type = 0;
        this.updateDt = 0;
        this.diplayName = '';
        this.avatarUrl = '';
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(GroupMember, null, [{
        key: 'convert2GroupMember',
        value: function convert2GroupMember(jsonObj) {
            var groupMember = new GroupMember();
            groupMember.memberId = jsonObj.memberId;
            groupMember.alias = jsonObj.alias;
            groupMember.type = jsonObj.type;
            groupMember.updateDt = jsonObj.updateDt;
            return groupMember;
        }
    }]);

    return GroupMember;
}();

/* harmony default export */ __webpack_exports__["a"] = (GroupMember);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_system__ = __webpack_require__(10);








var GetMinioUploadUrlHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(GetMinioUploadUrlHandler, _AbstractMessageHandl);

    function GetMinioUploadUrlHandler() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GetMinioUploadUrlHandler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (GetMinioUploadUrlHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(GetMinioUploadUrlHandler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GetMinioUploadUrlHandler, [{
        key: "match",
        value: function match(proto) {
            return proto.signal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["t" /* PUB_ACK */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["h" /* GMURL */];
        }
    }, {
        key: "notifyContent",
        value: function notifyContent(content) {
            var result = JSON.parse(content);
            return result;
        }
    }]);

    return GetMinioUploadUrlHandler;
}(__WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (GetMinioUploadUrlHandler);

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_system__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_localstore__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__message_messageStatus__ = __webpack_require__(53);










var SendMessageHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SendMessageHandler, _AbstractMessageHandl);

    function SendMessageHandler() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SendMessageHandler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SendMessageHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SendMessageHandler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SendMessageHandler, [{
        key: "match",
        value: function match(proto) {
            return proto.signal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["t" /* PUB_ACK */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["r" /* MS */];
        }
    }, {
        key: "processMessage",
        value: function processMessage(proto) {
            console.log("sendMessage Handler messageId " + proto.messageId);
            if (this.vueWebsocket.resolvePromiseMap.has(proto.messageId)) {
                var promiseReslove = this.vueWebsocket.resolvePromiseMap.get(proto.messageId);
                if (proto.content != '') {
                    var content = JSON.parse(proto.content);
                    console.log("SendMessageHandler messageId " + content.messageId + " timestamp protoMessageId " + promiseReslove.protoMessageId);
                    this.vueWebsocket.sendAction("updateProtoMessageUid", {
                        messageId: promiseReslove.protoMessageId,
                        messageUid: content.messageId
                    });

                    this.vueWebsocket.sendAction("updateMessageStatus", {
                        messageId: promiseReslove.protoMessageId,
                        status: __WEBPACK_IMPORTED_MODULE_8__message_messageStatus__["a" /* default */].Sent
                    });
                    __WEBPACK_IMPORTED_MODULE_7__utils_localstore__["a" /* default */].updateSendMessageCount();
                    promiseReslove.resolve('success');
                } else {
                    this.vueWebsocket.sendAction("updateMessageStatus", {
                        messageId: promiseReslove.protoMessageId,
                        status: __WEBPACK_IMPORTED_MODULE_8__message_messageStatus__["a" /* default */].SendFailure
                    });
                    promiseReslove.resolve('fail');
                }
                clearTimeout(promiseReslove.timeoutId);
                this.vueWebsocket.resolvePromiseMap.delete(proto.messageId);
            }
        }
    }]);

    return SendMessageHandler;
}(__WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SendMessageHandler);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constant_system__ = __webpack_require__(10);








var NotifyRecallMessageHandler = function (_AbstractMessageHandl) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NotifyRecallMessageHandler, _AbstractMessageHandl);

    function NotifyRecallMessageHandler() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NotifyRecallMessageHandler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotifyRecallMessageHandler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(NotifyRecallMessageHandler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(NotifyRecallMessageHandler, [{
        key: "match",
        value: function match(proto) {
            return proto.signal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["s" /* PUBLISH */] && proto.subSignal == __WEBPACK_IMPORTED_MODULE_6__constant_system__["u" /* RMN */];
        }
    }, {
        key: "processMessage",
        value: function processMessage(proto) {
            if (proto.content) {
                var notifyRecalMessage = JSON.parse(proto.content);
                console.log("from user " + notifyRecalMessage.fromUser + " messageUid " + notifyRecalMessage.messageUid);
                this.vueWebsocket.sendAction('updateRecallMessageContent', notifyRecalMessage);
            }
        }
    }]);

    return NotifyRecallMessageHandler;
}(__WEBPACK_IMPORTED_MODULE_5__abstractmessagehandler__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (NotifyRecallMessageHandler);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FriendInfo = function () {
    function FriendInfo() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FriendInfo);

        this.title = '';
        this.userInfos = [];
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FriendInfo, [{
        key: 'updateUserInfo',
        value: function updateUserInfo(userInfo) {
            var existUserInfo = this.userInfos.find(function (existUserInfo) {
                return existUserInfo.uid == userInfo.uid;
            });
            if (existUserInfo) {
                existUserInfo = userInfo;
            } else {
                this.userInfos.push(userInfo);
            }
        }
    }], [{
        key: 'createFriendInfo',
        value: function createFriendInfo(userInfo) {
            var friendInfo = new FriendInfo();
            friendInfo.title = userInfo.firstLetter;
            friendInfo.userInfos.push(userInfo);
            return friendInfo;
        }
    }]);

    return FriendInfo;
}();

/* harmony default export */ __webpack_exports__["a"] = (FriendInfo);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var StateSelectChateMessage = function StateSelectChateMessage() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StateSelectChateMessage);

    this.name = '';
    this.protoMessages = [];
};

/* harmony default export */ __webpack_exports__["a"] = (StateSelectChateMessage);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unReadCount__ = __webpack_require__(116);



var ProtoConversationInfo = function ProtoConversationInfo() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ProtoConversationInfo);

    this.lastMessage = {};
    this.timestamp = 0;
    this.draft = '';
    this.unreadCount = new __WEBPACK_IMPORTED_MODULE_1__unReadCount__["a" /* default */]();
    this.isTop = false;
    this.isSilent = false;
};

/* harmony default export */ __webpack_exports__["a"] = (ProtoConversationInfo);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var StateConversationInfo = function StateConversationInfo() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StateConversationInfo);

    this.conversationInfo = {};
};

/* harmony default export */ __webpack_exports__["a"] = (StateConversationInfo);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__conversationType__ = __webpack_require__(57);




var Conversation = function () {
    function Conversation(type, target, line) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Conversation);

        this.type = __WEBPACK_IMPORTED_MODULE_2__conversationType__["a" /* default */].Single;
        this.conversationType = this.type;
        this.target = '';
        this.line = 0;

        this.type = type;
        this.conversationType = type;
        this.target = target;
        this.line = line;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Conversation, [{
        key: "equal",
        value: function equal(conversation) {
            return this.type === conversation.type && this.target === conversation.target && this.line === conversation.line;
        }
    }]);

    return Conversation;
}();

/* harmony default export */ __webpack_exports__["a"] = (Conversation);

/***/ })
],[126]);


// WEBPACK FOOTER //
// static/js/app.2acbd0008933160e17d7.js